/**
 * video-editor/app.js — страница монтажной ленты.
 *
 * Разделение обязанностей намеренное и жёсткое:
 *   timeline.js — АРИФМЕТИКА ленты (что показывать в момент t, с какой
 *                 громкостью, где стоят титры после правки). Без DOM. Её
 *                 числами живут и превью, и файл.
 *   compose.js  — ОДИН рисовальщик кадра: превью и экспорт (hooks.compose
 *                 движка) зовут одну функцию.
 *   media.js    — файлы: что это, длина, звук, миниатюры, волна, перекодирование
 *                 того, что браузер не показывает, стоп-кадр.
 *   preview.js  — проигрыватель превью на <video> и Web Audio.
 *   здесь       — DOM ленты и инспектора, мышь, палец и клавиши, история
 *                 правок, экспорт через window.VideoMergeWebCodecs.
 *
 * ⚠️ Единица списания — КОМПОЗИЦИЯ, а не файл. У пофайловой единицы минимальная
 * работа редактора (лента из нескольких клипов) стоила бы несколько слотов
 * сразу — та же ловушка, из-за которой /split-screen считает по составному
 * ключу. Повтор той же ленты в тот же день бесплатен: ключ детерминирован и
 * считается по ИСХОДНЫМ файлам (перекодированная копия не меняет ключа —
 * `limitKeyOf`, и после F5 тоже).
 */
(function () {
'use strict';

var SLUG = 'video-editor';
var L = window.__veLang || {};
var LOC = window.__LOCALE || document.documentElement.lang || 'en';

function $(id) { return document.getElementById(id); }
function on(el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); }
function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }
/* Время ленты «м:сс.д». Округление ДО разбора на минуты: иначе 59.96 с
   печаталось «0:60.0». Разделитель — точка при любой локали: это отметка
   времени, как на любом таймлайне, а не дробное число. */
function fmt(t) {
    t = Math.round(Math.max(0, t || 0) * 10) / 10;
    var m = Math.floor(t / 60), s = t - m * 60;
    return m + ':' + (s < 10 ? '0' : '') + s.toFixed(1);
}
function fmtShort(s, step) {
    // Шаг линейки меньше секунды — подпись с десятыми, иначе две риски
    // подряд называются одинаково («0:01, 0:01»).
    if (step && step < 1) return fmt(s);
    var m = Math.floor(s / 60), r = Math.round(s - m * 60);
    if (r === 60) { m++; r = 0; }
    return m + ':' + (r < 10 ? '0' : '') + r;
}
/* Числа подписей — по правилам языка страницы (0,6 с по-русски, 0.6 s по-английски). */
var NF = {};
function nfmt(v, digits) {
    var k = String(digits);
    try { NF[k] = NF[k] || new Intl.NumberFormat(LOC, { minimumFractionDigits: digits, maximumFractionDigits: digits }); return NF[k].format(v); }
    catch (e) { return (+v).toFixed(digits); }
}
function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c];
    });
}
function icon(n) { return '<svg class="ve-i" aria-hidden="true"><use href="#ve-i-' + n + '"/></svg>'; }
function toast(msg, type) { if (msg && window.__toast) window.__toast(msg, type || 'info'); }
function ae(f, data) { try { window.__ae && window.__ae('feature_use', Object.assign({ slug: SLUG, f: f }, data || {})); } catch (e) {} }
function secLabel(v) { return nfmt(Math.round(v * 10) / 10, 1) + ' ' + (L.sec || 's'); }
function copy(o) { return JSON.parse(JSON.stringify(o)); }
function pct(v) { return Math.round(v * 100) + '%'; }

/* Цвета: поля «целиком» и заставка. Второй оттенок заставки темнее первого —
   совсем ровная заливка кодируется в килобайты, и кодировщик честно
   отвечает `output-starved` (compose.js: drawCard). */
var BG_COLORS = ['#000000', '#ffffff', '#1f2937', '#0f172a', '#7c3aed', '#db2777', '#059669', '#f59e0b'];
var CARD_PRESETS = [
    ['#1e293b', '#0f172a'], ['#111111', '#000000'], ['#f8fafc', '#e2e8f0'], ['#1d4ed8', '#1e3a8a'],
    ['#7c3aed', '#4c1d95'], ['#db2777', '#831843'], ['#059669', '#064e3b'], ['#f97316', '#9a3412'],
    ['#0ea5e9', '#6366f1'], ['#f43f5e', '#f59e0b'],
];
function shade(hex, k) {
    var m = /^#?([0-9a-f]{6})$/i.exec(hex || ''); var n = m ? parseInt(m[1], 16) : 0;
    var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    function ch(x) { return clamp(Math.round(k < 0 ? x * (1 + k) : x + (255 - x) * k), 0, 255); }
    return '#' + [ch(r), ch(g), ch(b)].map(function (x) { return (x < 16 ? '0' : '') + x.toString(16); }).join('');
}

/* Стили титров — одним нажатием: гарнитура, цвет, подложка и её цвет, кегль. */
var STYLES = [
    { key: 'classic', font: 'sans', color: '#ffffff', bg: 'shadow', bgColor: '#000000', sizePct: 6 },
    { key: 'subtitle', font: 'sans', color: '#ffffff', bg: 'box', bgColor: '#000000', sizePct: 4.5, y: 0.84, anim: 'none' },
    { key: 'title', font: 'narrow', color: '#ffffff', bg: 'shadow', bgColor: '#000000', sizePct: 11, y: 0.4, anim: 'pop' },
    { key: 'meme', font: 'display', color: '#ffd60a', bg: 'shadow', bgColor: '#000000', sizePct: 8 },
    { key: 'label', font: 'sans', color: '#111111', bg: 'box', bgColor: '#ffd60a', sizePct: 5 },
    { key: 'neon', font: 'sans', color: '#ffffff', bg: 'glow', bgColor: '#22d3ee', sizePct: 8 },
    { key: 'hand', font: 'hand', color: '#ffffff', bg: 'shadow', bgColor: '#000000', sizePct: 8 },
    { key: 'elegant', font: 'serif', color: '#fef3c7', bg: 'glow', bgColor: '#000000', sizePct: 7 },
];
var STYLE_CSS_FONT = { sans: "'VE Montserrat'", narrow: "'VE Oswald'", serif: "'VE Playfair'", hand: "'VE Caveat'", display: "'VE Russo'", script: "'VE Lobster'" };

document.addEventListener('DOMContentLoaded', function () {
    var TL = window.VideoEditorTimeline, C = window.VideoEditorCompose, RD = window.VideoEditorRedact, OV = window.VideoEditorOverlay;
    var upload = $('ve-upload'), ws = $('ve-workspace'), root = $('ve-root');
    if (!upload || !ws || !TL || !C || !window.VideoEditorMedia || !window.VideoEditorPreview) {
        if (ws && window.__handleError) window.__handleError(new Error('video-editor modules failed to load - please refresh the page'), SLUG);
        return;
    }

    /* ── состояние ──────────────────────────────────────────────────────── */
    function emptyProject() { return { clips: [], texts: [], audio: [], regions: [], overlays: [], aspect: 'auto' }; }
    var project = emptyProject();
    var sel = null;                 // { kind: 'clip'|'text'|'audio'|'region'|'overlay'|'tx'|'voice', id }
    var playhead = 0;
    var pxPerSec = 40;
    var seq = 0;
    var version = 0, built = -1, tlCache = null;
    var busy = false, abortCtl = null, lastResult = null, exportStartedAt = 0;
    var pending = {};               // mediaId → запись, которая ещё готовится
    var demoStop = null;            // показ появления титра: где остановиться
    var clipTab = 'frame';          // вкладка инспектора клипа, помнится между клипами
    var safeZones = false;
    var resultSnap = null;          // снимок проекта, из которого собран результат

    var media = window.VideoEditorMedia.create({ host: $('ve-media'), slug: SLUG });
    var canvas = $('ve-canvas');
    // Картинка наложения — тот же битмап в превью и в файле (compose.js).
    /* Картинка наложения — её битмап; у видео-наложения — <video> записи: из
       него рисовальщик берёт пропорции кадра (сам кадр у каждого наложения
       свой — превью и экспорт отдают его отдельно). */
    C.setImageResolver(function (id) {
        var r = media.get(id);
        if (!r) return null;
        return r.exportBitmap || r.bitmap || (r.kind === 'video' ? r.el : null);
    });
    var preview = window.VideoEditorPreview.create({
        canvas: canvas, media: media,
        afterDraw: drawSelection,
        onTick: function (t) {
            playhead = t; updatePlayhead();
            if (VO) VO.tick(t);
            if (preview.isPlaying()) followPlayhead();
            if (demoStop != null && t >= demoStop) { demoStop = null; preview.pause(); setPlayBtn(false); preview.render(playhead); }
        },
        onEnd: function () { setPlayBtn(false); if (VO) VO.ended(); },
        // Вкладку спрятали посреди дубля: лента встала, а микрофон писал бы
        // дальше — дубль заканчивается там, где встала лента.
        onPauseByHide: function () { setPlayBtn(false); if (VO && VO.isRecording()) VO.finish(); },
    });

    function nid(p) { return p + (++seq); }
    function norm(p) { p = p || {}; ['clips', 'texts', 'audio', 'regions', 'overlays'].forEach(function (k) { if (!Array.isArray(p[k])) p[k] = []; }); p.aspect = p.aspect || 'auto'; return p; }

    /* ── черновик: лента переживает F5 и падение вкладки ───────────────── */
    var DR = window.VideoEditorDraft ? window.VideoEditorDraft.create({
        slug: SLUG,
        t: function (k, f) { return L[k] || f; },
        track: ae,
        toast: toast,
        payload: draftPayload,
        apply: applyDraft,
        busy: function () { return !!(project.clips.length || project.audio.length || project.texts.length || project.overlays.length || Object.keys(pending).length); },
        notice: showNotice,
        reset: function () { resetAll(true); },
    }) : null;

    function limitKeyOf(r) {
        if (!r) return '';
        if (r.limitKey) return r.limitKey;
        try { return (window.__toolLimit && r.original) ? window.__toolLimit.fileKey(r.original) : ''; } catch (e) { return ''; }
    }
    /**
     * Записи файлов, на которые ссылается лента (титульный кадр файла не имеет).
     * forDraft — ещё и исходники перевёрнутых клипов: «обычный ход» после F5
     * должен найти свой файл, а собирать видео они не мешают.
     */
    function usedRecords(forDraft) {
        var used = {};
        project.clips.forEach(function (c) {
            if (c.mediaId != null && c.kind !== 'color') used[c.mediaId] = 1;
            if (forDraft && c.reverseOf && c.reverseOf.mediaId != null) used[c.reverseOf.mediaId] = 1;
        });
        project.audio.forEach(function (a) { used[a.mediaId] = 1; });
        project.overlays.forEach(function (o) { used[o.mediaId] = 1; });
        return Object.keys(used).map(function (id) { return media.get(id); }).filter(Boolean);
    }
    function missingNames() {
        var out = {};
        usedRecords().forEach(function (r) { if (r.state === 'missing') out[r.name] = 1; });
        return Object.keys(out);
    }
    function hasWork() { return !!(project.clips.length || project.texts.length || project.audio.length || project.regions.length || project.overlays.length); }

    /* Что уносит черновик: проект (JSON) и байты файлов — те, что влезают
       (draft.js: pickFiles). Остальные — по имени и размеру, вернутся выбором. */
    function draftPayload() {
        if (!project.clips.length && !project.audio.length && !project.texts.length && !project.overlays.length) return null;
        var recs = usedRecords(true);
        // Файл ещё готовится (перекодирование): держится прежняя запись.
        if (recs.some(function (r) { return r.state !== 'ready' && r.state !== 'missing'; })) return null;
        var fits = window.VideoEditorDraft.pickFiles(recs.map(function (r) { return { file: r.state === 'ready' ? r.file : null }; }));
        var files = [];
        var desc = recs.map(function (r, i) {
            var d = { id: r.id, kind: r.kind, name: r.name, size: r.original ? r.original.size : (r.want ? r.want.size : 0),
                duration: r.duration, width: r.width, height: r.height, fps: r.fps, hasAudio: r.hasAudio,
                converted: r.converted || null, limitKey: limitKeyOf(r), file: -1 };
            if (fits[i]) { d.file = files.length; files.push(r.file); }
            return d;
        });
        var t = tl();
        return {
            v: 1,
            state: { project: copy(project), media: desc, seq: seq },
            files: files,
            label: draftLabel(),
            preview: draftPreview(),
            meta: { clips: project.clips.length, dur: Math.round(t.duration), aspect: project.aspect },
        };
    }
    function draftLabel() {
        var first = project.clips.filter(function (c) { return c.kind !== 'color'; })[0] || project.audio[0];
        var base = first ? String(first.name || '').replace(/\.[^.]+$/, '') : '';
        var n = project.clips.length;
        return base ? (base + (n > 1 ? ' +' + (n - 1) : '') + ' · ' + fmt(tl().duration)) : '';
    }
    var previewCache = { at: 0, url: '' };
    function draftPreview() {
        var now = Date.now();
        if (previewCache.url && now - previewCache.at < 2000) return previewCache.url;
        try {
            var k = 160 / Math.max(canvas.width, canvas.height);
            var c = document.createElement('canvas');
            c.width = Math.max(1, Math.round(canvas.width * k)); c.height = Math.max(1, Math.round(canvas.height * k));
            c.getContext('2d').drawImage(canvas, 0, 0, c.width, c.height);
            previewCache = { at: now, url: c.toDataURL('image/jpeg', 0.7) };
        } catch (e) {}
        return previewCache.url;
    }

    /* Положить сохранённый проект на ленту. Файлы из черновика проходят тот
       же разбор, что свежий выбор; недостающие становятся «нет файла» и ждут. */
    async function applyDraft(d) {
        var st = d.state || {}, files = d.files || [];
        resetAll(true);
        var map = {}, missing = [], wait = [], shown = [];
        (st.media || []).forEach(function (m) {
            var f = (m.file >= 0 && files[m.file]) ? files[m.file] : null;
            var r = f ? media.add(f) : media.addMissing(m);
            if (f) {
                r.name = m.name || r.name;
                if (m.converted) r.converted = m.converted;
                wait.push(r.ready);
                shown.push(f);
            } else { missing.push(m.name); shown.push({ name: m.name || '', size: m.size || 0 }); }
            if (m.limitKey) r.limitKey = m.limitKey;
            map[m.id] = r;
        });
        await Promise.all(wait);
        var pr = norm(st.project || emptyProject());
        ['clips', 'audio', 'overlays'].forEach(function (k) {
            pr[k] = pr[k].filter(function (x) {
                if (k === 'clips' && x.kind === 'color') return true;
                var r = map[x.mediaId];
                if (!r || r.state === 'failed') return false;
                x.mediaId = r.id;
                // Исходник перевёрнутого клипа: не вернулся — клип остаётся
                // перевёрнутым, только «обычный ход» уже не предложить.
                if (x.reverseOf) {
                    var ro = map[x.reverseOf.mediaId];
                    if (ro && ro.state !== 'failed') x.reverseOf.mediaId = ro.id; else delete x.reverseOf;
                }
                return true;
            });
        });
        project = pr;
        seq = Math.max(seq, st.seq || 0);
        sel = null; playhead = 0;
        hist = { stack: [], idx: -1, key: null, at: 0 };
        touch();
        if (hasWork()) showWorkspace();
        // Зона загрузки — в строку «файлы проекта», как после выбора: иначе над
        // открытым проектом стояла большая пустая зона «перетащите файлы».
        try { if (shown.length && upload.__uploaderCollapse) upload.__uploaderCollapse(shown); } catch (e) {}
        fitAspectCanvas();
        userZoomed = false; zoomFit();
        refresh();
        commit();
        if (missing.length) showNotice(String(L.draft_missing || '').replace(':names', missing.join(', ')), 'missing');
        return { missing: missing };
    }

    /* ── строка извещений над прибором ─────────────────────────────────── */
    function showNotice(text, kind) {
        var el = $('ve-notice');
        if (!el) return;
        $('ve-notice-text').textContent = text || '';
        $('ve-notice-add').hidden = kind !== 'missing';
        el.classList.toggle('warn', kind === 'missing' || kind === 'lost');
        el.hidden = !text;
    }
    function hideNotice() { var el = $('ve-notice'); if (el) el.hidden = true; }

    /* ── сохранённые проекты ───────────────────────────────────────────── */
    function refreshProjects() {
        if (!DR || !DR.available()) return;
        var n = DR.rows().length;
        $('ve-projects').hidden = !n;
        $('ve-projects-n').textContent = n ? String(n) : '';
    }
    function renderProjects(res) {
        var host = $('ve-projects-list');
        var rows = res.rows || [], bz = res.busy || {}, cur = DR.current();
        if (!rows.length) { host.innerHTML = '<p class="tc-hint" style="padding:8px">' + esc(L.projects_empty || '') + '</p>'; return; }
        host.innerHTML = rows.map(function (r) {
            var m = r.meta || {};
            var status = r.id === cur ? L.project_open_now : bz[r.id] ? L.project_other_tab
                : r.trimmed ? L.project_trimmed
                : (m.exportedAt && m.exportedAt >= (m.editedAt || 0)) ? L.project_exported : L.project_not_exported;
            var name = r.label || L.project_untitled || '';
            return '<div class="ve-proj' + (r.id === cur ? ' cur' : '') + '">'
                + '<button type="button" class="ve-proj-open" data-open="' + esc(r.id) + '">'
                + (r.preview ? '<img src="' + esc(r.preview) + '" alt="">' : '<span class="ve-proj-noimg" aria-hidden="true">' + icon('film') + '</span>')
                + '<span class="ve-proj-txt"><span class="ve-proj-nm">' + esc(name) + '</span>'
                + '<span class="ve-proj-sub">' + esc(DR.when(m.editedAt || r.savedAt)) + ' · ' + esc(status || '') + '</span></span></button>'
                + '<button type="button" class="ve-proj-del" data-del="' + esc(r.id) + '" title="' + esc(L.project_delete || '') + '" aria-label="' + esc((L.project_delete || '') + ': ' + name) + '">' + icon('x') + '</button>'
                + '</div>';
        }).join('');
    }
    function toggleProjects(open) {
        var pop = $('ve-projects-pop'), btn = $('ve-projects-btn');
        if (open == null) open = pop.hidden;
        if (!open) { pop.hidden = true; btn.setAttribute('aria-expanded', 'false'); return; }
        DR.list().then(function (res) {
            renderProjects(res);
            pop.hidden = false;
            btn.setAttribute('aria-expanded', 'true');
            refreshProjects();
            ae('projects_open', { n: res.rows.length });
        });
    }
    on($('ve-projects-btn'), 'click', function (ev) { ev.stopPropagation(); if (!busy) toggleProjects(); });
    on($('ve-projects-list'), 'click', function (ev) {
        var o = ev.target.closest('[data-open]'), del = ev.target.closest('[data-del]');
        if (o) {
            var id = o.getAttribute('data-open');
            toggleProjects(false);
            if (id !== DR.current()) DR.open(id, {}).then(refreshProjects);
        } else if (del) {
            DR.remove(del.getAttribute('data-del')).then(function () { return DR.list(); }).then(function (res) { renderProjects(res); refreshProjects(); });
            ae('project_delete');
        }
    });
    on(document, 'click', function (ev) {
        var pop = $('ve-projects-pop');
        if (pop && !pop.hidden && !pop.contains(ev.target) && !$('ve-projects-btn').contains(ev.target)) toggleProjects(false);
    });
    on($('ve-notice-add'), 'click', function () { if (upload.__uploaderOpen) upload.__uploaderOpen(); });
    on($('ve-notice-x'), 'click', hideNotice);

    function tl() {
        if (built !== version) {
            tlCache = TL.build(project.clips, project.texts, { audio: project.audio, overlays: project.overlays });
            built = version;
        }
        return tlCache;
    }
    function touch() { version++; }

    /* ── история правок ─────────────────────────────────────────────────
       Снимок проекта — маленький JSON (файлы живут в media, в проекте только
       их id), поэтому «отменить» — подстановка прежнего снимка. Непрерывный
       жест (ползунок, перетаскивание) — ОДНА запись: иначе одна протяжка
       громкости съедала бы всю глубину истории. */
    var hist = { stack: [], idx: -1, key: null, at: 0 };
    function snap() { return JSON.stringify(project); }
    function commit(key) {
        var s = snap();
        if (hist.idx >= 0 && hist.stack[hist.idx] === s) return;
        var now = Date.now(), counted = true;
        if (key && hist.key === key && now - hist.at < 900 && hist.idx === hist.stack.length - 1 && hist.idx > 0) {
            hist.stack[hist.idx] = s;
            counted = false;
        } else {
            hist.stack.length = hist.idx + 1;
            hist.stack.push(s);
            if (hist.stack.length > 120) hist.stack.shift();
            hist.idx = hist.stack.length - 1;
        }
        hist.key = key || null; hist.at = now;
        syncUndo();
        guardLeave();
        syncStale();
        if (DR) DR.touch(counted);
    }
    /* «Точно уйти?» — только когда уход правда теряет работу. Ленту черновик
       (draft.js) сохраняет сам, и F5 её вернёт; но файл больше порога черновика
       хранится лишь именем — его пришлось бы выбирать заново. Без хранилища
       черновиков (приватный режим) лента живёт только во вкладке. */
    function guardLeave() {
        var U = window.__unsavedWork;
        if (!U) return;
        try {
            var need = hasWork() && (!DR || !DR.available() || unsavedBytes());
            if (need && !U.isArmed()) U.arm('ve:project');
            else if (!need && U.isArmed() && U.reason() === 've:project') U.disarm();
        } catch (e) {}
    }
    function unsavedBytes() {
        var recs = usedRecords(true);
        if (recs.some(function (r) { return r.state === 'missing'; })) return true;
        var fits = window.VideoEditorDraft.pickFiles(recs.map(function (r) { return { file: r.state === 'ready' ? r.file : null }; }));
        return fits.some(function (ok, i) { return !ok && recs[i].state === 'ready'; });
    }
    function restore(s) {
        project = norm(JSON.parse(s));
        touch();
        fitAspectCanvas();
        if (DR) DR.touch(true);
        if (sel && sel.kind !== 'voice' && !findSel()) sel = null;
        refresh();
        syncStale();
    }
    function undo() { if (hist.idx > 0) { hist.idx--; hist.key = null; restore(hist.stack[hist.idx]); syncUndo(); ae('undo'); } }
    function redo() { if (hist.idx < hist.stack.length - 1) { hist.idx++; hist.key = null; restore(hist.stack[hist.idx]); syncUndo(); } }
    function syncUndo() {
        $('ve-undo').disabled = !(hist.idx > 0);
        $('ve-redo').disabled = !(hist.idx < hist.stack.length - 1);
    }

    /* ── правка главной дорожки: титры, скрытие и звук едут за кадром ─────
       Правка, которая сдвигает клипы (обрезка, скорость, удаление, вставка,
       перестановка, переход), сначала запоминает, над каким кадром стоит
       каждый элемент поверх ленты, а потом ставит его туда же
       (TL.anchorsOf/reanchor). Непрерывный жест (протяжка края, ползунок) —
       якоря от НАЧАЛА жеста: иначе упор в край копил бы ошибку. */
    var gesture = null;
    function overItems() { return { texts: project.texts, audio: project.audio, regions: project.regions, overlays: project.overlays }; }
    function editMain(key, fn) {
        var now = Date.now();
        if (!key || !gesture || gesture.key !== key || now - gesture.at > 900) {
            gesture = { key: key, anchors: TL.anchorsOf(project.clips, overItems()), items: copy(overItems()) };
        }
        gesture.at = now;
        fn();
        project.texts = copy(gesture.items.texts); project.audio = copy(gesture.items.audio);
        project.regions = copy(gesture.items.regions); project.overlays = copy(gesture.items.overlays);
        TL.reanchor(project.clips, overItems(), gesture.anchors);
        if (!key) gesture = null;
    }
    /** Последний клип не держит перехода: соседа справа у него нет. */
    function tidyTransitions() {
        var n = project.clips.length;
        if (n) project.clips[n - 1].tx = null;
    }

    /* ── выбор ──────────────────────────────────────────────────────────── */
    function listOf(kind) {
        return kind === 'clip' || kind === 'tx' ? project.clips : kind === 'text' ? project.texts
            : kind === 'audio' ? project.audio : kind === 'region' ? project.regions
            : kind === 'overlay' ? project.overlays : [];
    }
    function findSel() {
        if (!sel) return null;
        var list = listOf(sel.kind);
        for (var i = 0; i < list.length; i++) if (list[i].id === sel.id) return { item: list[i], index: i };
        return null;
    }
    function select(kind, id) {
        if (VO && VO.isActive() && kind !== 'voice') VO.close();
        sel = (kind && id != null) ? { kind: kind, id: id } : null;
        syncInspector();
        renderTimeline();
        preview.render(playhead);
    }
    /** Где элемент стоит на ленте (для «показать выбранное»). */
    function spanOfSel(kind, id) {
        var t = tl();
        if (kind === 'clip') { for (var i = 0; i < t.clips.length; i++) if (t.clips[i].id === id) return t.spanOf(i); }
        if (kind === 'audio') { for (var j = 0; j < t.audio.length; j++) if (t.audio[j].id === id) { var s = t.itemSpan(j); return { start: s.start, end: s.end }; } }
        var list = listOf(kind);
        for (var k = 0; k < list.length; k++) if (list[k].id === id) return { start: list[k].start, end: list[k].end };
        return null;
    }
    /* Выбранное должно быть ВИДНО: выбрал второй клип и крутишь цвет — а превью
       показывает первый, и кажется, что ползунок не работает (осмотр 30.09).
       Ползунок вне выбранного — встаёт в его начало (или на место щелчка). */
    function bringIntoView(kind, id, at) {
        var sp = spanOfSel(kind, id);
        if (!sp || !(sp.end > sp.start)) return;
        var t = at != null ? at : playhead;
        if (t >= sp.start && t < sp.end - 1e-3) { if (at != null) seekTo(at); return; }
        seekTo(Math.min(sp.end - 0.01, sp.start + Math.min(0.5, (sp.end - sp.start) / 2)));
    }

    /* ── загрузка ───────────────────────────────────────────────────────── */

    /* ⚠️ Через `__bindUploaderFile`, а НЕ голым addEventListener: голая
       подписка гонится с примитивом (файл выбран раньше, чем модуль успел
       подписаться). Колбэк зовётся как (File, detail); множественный выбор —
       в `detail.files`. */
    window.__bindUploaderFile(upload, function (file, detail) {
        var files = (detail && detail.files && detail.files.length)
            ? Array.prototype.slice.call(detail.files)
            : (file ? [file] : []);
        if (files.length) addFiles(files);
    });
    /* × на строке файлов — это «закрыть монтаж», как «Новый монтаж»: проект
       остаётся в «Проектах», лента чистая. */
    upload.addEventListener('tool-uploader:clear', function () { if (!busy) resetAll(); });
    /* Часть выбора не влезла по размеру — остальное встало, а какой файл
       отказан, говорит строка зоны (и сюда же тост: зона могла быть свёрнута). */
    upload.addEventListener('tool-uploader:reject', function (ev) {
        var d = ev.detail || {};
        if (d.partial && d.msg) toast(d.msg, 'warning');
    });
    /* «Картинка поверх видео»: следующий выбранный файл-картинка ляжет на
       дорожку наложений, а не клипом на ленту. Отмена окна выбора снимает
       намерение (событие cancel у <input type=file>). */
    var overlayPick = 0;
    try {
        var upIn = upload.__uploaderInput || document.getElementById('ve-upload-input');
        if (upIn) upIn.addEventListener('cancel', function () { overlayPick = 0; });
    } catch (e) {}

    function isSubs(f) { return /\.(srt|vtt|ass|ssa)$/i.test((f && f.name) || ''); }

    async function addFiles(files) {
        var wantOverlay = overlayPick && Date.now() - overlayPick < 10 * 60 * 1000;
        overlayPick = 0;
        var subs = files.filter(isSubs);
        files = files.filter(function (f) { return !isSubs(f); });
        /* Файл, которого не хватало восстановленному проекту (по имени и
           размеру), встаёт на СВОИ места на ленте, а не новым клипом в конец. */
        var relinked = [];
        var recs = files.map(function (f) {
            var miss = media.findMissing(f);
            if (miss) { relinked.push(media.relink(miss.id, f)); return null; }
            var r = media.add(f); if (r.kind) pending[r.id] = r; return r;
        }).filter(Boolean);
        if (recs.length || relinked.length || subs.length) showWorkspace();
        renderPending();
        if (relinked.length) {
            await Promise.all(relinked.map(function (r) { return r.ready; }));
            relinked.forEach(function (r) {
                r.lifted = null;
                if (r.state !== 'ready') { toast(String(L.clip_unreadable || '').replace(':name', r.name), 'error'); return; }
                project.clips.forEach(function (c) { if (c.mediaId === r.id && c.kind === 'video') c.hasAudio = r.hasAudio !== false; });
            });
            touch(); refresh();
            ae('draft_relinked', { n: relinked.length });
            if (!missingNames().length) hideNotice();
        }
        var added = 0;
        for (var i = 0; i < recs.length; i++) {
            var r = recs[i];
            if (!r.kind) { toast((L.kind_unsupported || '').replace(':name', r.name), 'error'); delete pending[r.id]; continue; }
            await r.ready;
            delete pending[r.id];
            renderPending();
            if (r.state !== 'ready') {
                var why = r.error === 'unplayable' ? L.convert_failed : r.error === 'heic' ? L.heic_unreadable
                    : r.kind === 'image' ? L.photo_unreadable : r.kind === 'audio' ? L.audio_unreadable : L.clip_unreadable;
                toast(String(why || '').replace(':name', r.name), 'error');
                media.remove(r.id);
                continue;
            }
            if (r.kind === 'audio') addAudioItem(r);
            else if ((r.kind === 'image' || r.kind === 'video') && wantOverlay && project.clips.length) addOverlayItem(r);
            else addClip(r);
            added++;
        }
        for (var s = 0; s < subs.length; s++) { if (await importSubs(subs[s])) added++; }
        if (!added) { if (!hasWork()) hideWorkspaceIfEmpty(); else commit(); return; }
        touch();
        fitAspectCanvas();
        if (!userZoomed) zoomFit();
        if (!sel) {
            var first = project.clips[0] || project.audio[0];
            if (first) sel = { kind: project.clips[0] ? 'clip' : 'audio', id: first.id };
        }
        refresh();
        commit();
        try { window.__stage && window.__stage('clips_loaded'); } catch (e) {}
        try { window.__aeFunnel && window.__aeFunnel('clips_loaded', { n: project.clips.length, audio: project.audio.length, overlays: project.overlays.length }); } catch (e) {}
    }

    function addClip(r) {
        var isImg = r.kind === 'image';
        var d = isImg ? 4 : r.duration;
        project.clips.push({
            id: nid('c'), kind: isImg ? 'image' : 'video', mediaId: r.id, name: r.name,
            duration: d, trimStart: 0, trimEnd: d, speed: 1, volume: 1, mute: false, fadeIn: 0, fadeOut: 0,
            rotation: 0, fit: isImg ? 'blur' : 'contain', tx: null,
            width: r.width, height: r.height, hasAudio: !isImg && r.hasAudio !== false,
        });
    }
    function addAudioItem(r) {
        var t = tl();
        var start = (playhead > 0.05 && playhead < t.duration - 0.2) ? playhead : 0;
        project.audio.push({
            id: nid('a'), mediaId: r.id, name: r.name, duration: r.duration,
            start: start, trimStart: 0, trimEnd: r.duration, volume: 1, fadeIn: 0, fadeOut: 1, loop: false,
        });
        if (!project.clips.length) toast(L.audio_needs_clip, 'info');
    }
    /* Логотип или картинка поверх видео: по умолчанию — от ползунка до конца
       ролика в правом верхнем углу (чаще всего это знак канала). Видео поверх
       видео — «картинка в картинке» в правом нижнем углу, длиной не больше
       того, что осталось от ролика (остальное всё равно не попало бы в кадр). */
    function addOverlayItem(r, opts) {
        opts = opts || {};
        var t = tl(), dur = t.duration > 0 ? t.duration : 5;
        var start = opts.start != null ? opts.start : ((playhead > 0.05 && playhead < dur - 0.5) ? playhead : 0);
        var isVid = r.kind === 'video';
        var w = isVid ? 0.36 : 0.22, aspect = aspectRatio();
        var h = w * (r.height / Math.max(1, r.width)) * aspect;
        var o = { id: nid('o'), kind: isVid ? 'video' : 'image', mediaId: r.id, name: r.name, start: start,
            x: 1 - 0.04 - w / 2, y: isVid ? clamp(1 - 0.05 - h / 2, h / 2, 1) : 0.05 + h / 2, w: w, opacity: 1, anim: 'fade' };
        if (isVid) {
            var ts = opts.trimStart != null ? opts.trimStart : 0;
            var te = opts.trimEnd != null ? opts.trimEnd : Math.min(r.duration, ts + Math.max(0.5, dur - start));
            o.duration = r.duration; o.trimStart = ts; o.trimEnd = Math.max(ts + 0.1, te);
            o.end = start + (o.trimEnd - o.trimStart);
            o.volume = opts.volume != null ? opts.volume : 1; o.mute = !!opts.mute; o.hasAudio = r.hasAudio !== false;
        } else o.end = Math.max(start + 1, dur);
        project.overlays.push(o);
        sel = { kind: 'overlay', id: o.id };
        if (!opts.silent) toast(isVid ? L.overlay_video_added : L.overlay_added, 'success');
        ae('overlay_added', { k: o.kind });
        return o;
    }

    /* Субтитры .srt/.vtt/.ass — титрами внизу кадра, каждая реплика в своём
       окне. Кодировку (cp1251 у русских файлов) угадывает общий парсер. */
    async function importSubs(file) {
        var SP = window.SubtitleParser;
        if (!SP) { toast(String(L.subs_failed || '').replace(':name', file.name), 'error'); return false; }
        try {
            var res = await SP.readFile(file);
            var ext = String(file.name || '').split('.').pop().toLowerCase();
            var cues = SP.parse(res.text, { ext: ext }).filter(function (c) { return c && c.text && c.end > c.start; });
            if (!cues.length) { toast(String(L.subs_empty || '').replace(':name', file.name), 'warning'); return false; }
            cues.forEach(function (c) {
                project.texts.push({ id: nid('t'), text: String(c.text).trim(), start: Math.max(0, c.start), end: Math.max(c.start + 0.2, c.end),
                    x: 0.5, y: 0.83, sizePct: 4.5, color: '#ffffff', bg: 'box', bgColor: '#000000', align: 'center',
                    fadeSec: 0.1, font: 'sans', anim: 'none' });
            });
            toast(String(L.subs_added || '').replace(':n', String(cues.length)), 'success');
            ae('subs_imported', { n: cues.length, ext: ext });
            return true;
        } catch (e) {
            toast(String(L.subs_failed || '').replace(':name', file.name), 'error');
            ae('subs_failed', { err: String(e && e.message || e).slice(0, 80) });
            return false;
        }
    }

    media.on(function (m) {
        if (m.type === 'progress') renderPending();
        if (m.type === 'thumbs' || m.type === 'peaks') { scheduleTimeline(); if (m.type === 'thumbs' && clipTab === 'look') scheduleFilterThumbs(); }
        if (m.type === 'duration') {
            var rec = media.get(m.id);
            project.audio.forEach(function (a) {
                if (a.mediaId === m.id && rec && rec.duration > 0 && !(a.duration > 0)) { a.duration = rec.duration; a.trimEnd = rec.duration; }
            });
            touch(); refresh();
        }
    });

    function renderPending() {
        var list = Object.keys(pending).map(function (k) { return pending[k]; }).filter(function (r) { return r.state === 'converting' || r.state === 'needs-convert'; });
        var el = $('ve-tl-stats');
        if (list.length) {
            el.textContent = list.map(function (r) {
                return String(L.converting || '').replace(':name', r.name).replace(':pct', String(Math.round((r.progress || 0) * 100)));
            }).join(' · ');
        } else updateStats();
    }

    function showWorkspace() {
        if (!ws.hidden) return;
        ws.hidden = false;
        fitAspectCanvas();
        zoomFit();
    }
    function hideWorkspaceIfEmpty() { if (!hasWork()) ws.hidden = true; }

    /* ── кадр проекта ───────────────────────────────────────────────────── */
    function aspectRatio() { return TL.aspectOf(project.aspect, project.clips); }
    function fitAspectCanvas() {
        var a = aspectRatio();
        var s = TL.outputSize(a, 540);
        // Превью: длинная сторона ~960 px — резко на экране и дёшево рисовать.
        var k = 960 / Math.max(s.w, s.h);
        preview.setSize(Math.round(s.w * k / 2) * 2, Math.round(s.h * k / 2) * 2);
        var segs = $('ve-aspect').querySelectorAll('[data-aspect]');
        for (var i = 0; i < segs.length; i++) {
            var onA = segs[i].getAttribute('data-aspect') === project.aspect;
            segs[i].classList.toggle('on', onA);
            segs[i].setAttribute('aria-checked', onA ? 'true' : 'false');
        }
    }
    on($('ve-aspect'), 'click', function (ev) {
        var b = ev.target.closest('[data-aspect]');
        if (!b || busy) return;
        project.aspect = b.getAttribute('data-aspect');
        touch(); fitAspectCanvas(); refresh(); commit();
        ae('aspect', { a: project.aspect });
    });

    /* ── перерисовка ────────────────────────────────────────────────────── */
    var rafPending = 0;
    var previewAt = null;           // пока тянут правый край клипа — превью показывает его конец
    function refresh() {
        var t = tl();
        playhead = clamp(playhead, 0, Math.max(0, t.duration));
        preview.setModel(t, project.regions);
        renderTimeline();
        syncInspector();
        if (!preview.isPlaying()) preview.render(previewAt != null ? clamp(previewAt, 0, t.duration) : playhead);
        updateStats();
        updateEstimate();
    }
    function scheduleRefresh() {
        if (rafPending) return;
        rafPending = requestAnimationFrame(function () { rafPending = 0; refresh(); });
    }
    function updateStats() {
        var t = tl();
        $('ve-dur').textContent = fmt(t.duration);
        $('ve-cur').textContent = fmt(playhead);
        if (Object.keys(pending).length) return;
        $('ve-tl-stats').textContent = (L.clips_count || ':n').replace(':n', String(t.clips.length));
    }

    /* ── лента: отрисовка ───────────────────────────────────────────────── */
    var inner = $('ve-tl-inner'), ruler = $('ve-ruler'), scroller = $('ve-tl-scroll');
    var trackV = $('ve-track-video'), trackT = $('ve-track-text'), trackA = $('ve-track-audio'), trackR = $('ve-track-redact'), trackO = $('ve-track-over');
    var head = $('ve-playhead');
    var drag = null;

    function extent() { var t = tl(); return Math.max(t.extent(), 1); }
    /* Лента всегда слева направо, и на арабской странице тоже (direction:ltr в
       стилях): миниатюры и волна — канвас, [dir=rtl] его не зеркалит, и два
       времени в одном блоке шли бы навстречу друг другу (/drum-separator,
       18.08). */
    function x2t(clientX) {
        var r = inner.getBoundingClientRect();
        return Math.max(0, (clientX - r.left) / pxPerSec);
    }
    function pos(sec) { return (sec * pxPerSec) + 'px'; }
    function place(el, a, b) { el.style.insetInlineStart = pos(a); el.style.width = Math.max(10, (b - a) * pxPerSec) + 'px'; }

    /* Полосы: пересекающиеся по времени элементы одной дорожки встают друг под
       друга, а не друг на друга (голос поверх музыки, два титра, два лица).
       Жадно по началу — первая полоса, где предыдущий уже кончился. Пока идёт
       перетаскивание, полосы не пересчитываются: иначе элемент прыгал бы под
       пальцем из полосы в полосу. */
    var LANE = {
        text: { h: 33, base: 38, cls: 't-text' }, audio: { h: 47, base: 52, cls: 't-audio' },
        region: { h: 29, base: 34, cls: 't-redact' }, overlay: { h: 35, base: 40, cls: 't-over' },
    };
    var laneMemo = {};
    function lanesFor(kind, items, spanOf) {
        var ids = items.map(function (x) { return x.id; }).join('|');
        var memo = laneMemo[kind];
        if (drag && memo && memo.ids === ids) return memo.res;
        var order = items.map(function (x, i) { return i; }).sort(function (a, b) {
            return spanOf(items[a], a)[0] - spanOf(items[b], b)[0] || a - b;
        });
        var ends = [], byId = {};
        order.forEach(function (i) {
            var sp = spanOf(items[i], i), l = 0;
            while (l < ends.length && ends[l] > sp[0] + 1e-6) l++;
            byId[items[i].id] = l;
            ends[l] = sp[1];
        });
        var res = { byId: byId, n: Math.max(1, ends.length) };
        laneMemo[kind] = { ids: ids, res: res };
        return res;
    }
    function sizeTrack(track, kind, n, empty) {
        var h = LANE[kind].base + (n - 1) * LANE[kind].h;
        track.style.height = empty ? '' : h + 'px';
        track.classList.toggle('is-empty', !!empty);
        var hd = document.querySelector('.ve-tl-heads .ve-th.' + LANE[kind].cls);
        if (hd) { hd.style.height = empty ? '' : h + 'px'; hd.classList.toggle('is-empty', !!empty); }
    }
    function laneTop(kind, lane) { return (4 + lane * LANE[kind].h) + 'px'; }
    function itemA11y(el, label) {
        el.tabIndex = 0;
        el.setAttribute('role', 'button');
        el.setAttribute('aria-label', label);
    }

    function renderTimeline() {
        var t = tl();
        // Фокус клавиатуры живёт на элементе ленты — после перерисовки он
        // возвращается на элемент с тем же id (узлы пересоздаются).
        var ae0 = document.activeElement, focusKey = null;
        if (ae0 && inner.contains(ae0)) focusKey = ae0.dataset.id ? 'id:' + ae0.dataset.id : (ae0.dataset.tx ? 'tx:' + ae0.dataset.tx : null);

        var w = Math.max(scroller.clientWidth || 320, Math.ceil(extent() * pxPerSec) + 80);
        inner.style.width = w + 'px';

        // линейка
        var step = pickStep(pxPerSec), html = '';
        for (var s = 0; s <= w / pxPerSec + step; s += step) html += '<span class="ve-tick" style="inset-inline-start:' + pos(s) + '">' + fmtShort(s, step) + '</span>';
        ruler.innerHTML = html;

        // клипы
        trackV.innerHTML = '';
        if (!t.clips.length) trackV.appendChild(addBtn('media', L.track_add_media));
        for (var i = 0; i < t.clips.length; i++) {
            var c = t.clips[i], sp = t.spanOf(i);
            if (!sp || sp.end - sp.start <= 0) continue;
            var d = document.createElement('div');
            var isSel = sel && sel.kind === 'clip' && sel.id === c.id;
            var crec = c.kind === 'color' ? null : media.get(c.mediaId), gone = !!(crec && crec.state === 'missing');
            d.className = 've-item ve-clip' + (c.kind === 'image' ? ' is-img' : '') + (c.kind === 'color' ? ' is-card' : '') + (isSel ? ' is-sel' : '') + (gone ? ' is-missing' : '');
            d.dataset.id = c.id;
            place(d, sp.start, sp.end);
            if (drag && drag.kind === 'trimL' && drag.id === c.id) {
                // Левый край идёт за пальцем, а модель не меняется до
                // отпускания: иначе вся лента правее прыгала бы под пальцем.
                var off = (drag.cut || 0) * pxPerSec;
                d.style.insetInlineStart = (sp.start * pxPerSec + off) + 'px';
                d.style.width = Math.max(10, (sp.end - sp.start) * pxPerSec - off) + 'px';
            }
            if (drag && drag.kind === 'move' && drag.id === c.id && drag.moved) d.classList.add('is-ghost');
            var nm = c.kind === 'color' ? (L.card || '') : c.name;
            itemA11y(d, nm + ' · ' + fmt(sp.end - sp.start));
            d.appendChild(thumbCanvas(c, (sp.end - sp.start) * pxPerSec));
            var flags = '';
            if (c.flipH || c.flipV) flags += icon('fliph');
            if ((c.tone || 'none') !== 'none') flags += icon('sparkles');
            if (c.reversed) flags += icon('reverse');
            if (c.mute && c.hasAudio) flags += icon('mute');
            d.insertAdjacentHTML('beforeend', '<span class="ve-item-name">' + esc(nm) + (gone ? ' · ' + esc(L.clip_missing || '') : '') + '</span>'
                + (flags ? '<span class="ve-clip-flags">' + flags + '</span>' : '')
                + '<span class="ve-clip-badge">' + (c.speed !== 1 ? nfmt(Math.round(c.speed * 100) / 100, c.speed * 100 % 100 === 0 ? 0 : 2) + '× · ' : '') + fmt(sp.end - sp.start) + '</span>'
                + '<span class="ve-grip l"></span><span class="ve-grip r"></span>');
            trackV.appendChild(d);
        }
        // переходы на стыках
        for (var j = 0; j < t.clips.length - 1; j++) {
            if (!(t.effDur[j] > 0) || !(t.effDur[j + 1] > 0)) continue;
            var ov = t.overlaps[j], jx = t.starts[j + 1] + ov / 2;
            if (ov > 0) {
                var band = document.createElement('div');
                band.className = 've-txband';
                place(band, t.starts[j + 1], t.starts[j + 1] + ov);
                trackV.appendChild(band);
            }
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 've-txb' + (t.clips[j].tx ? ' has' : '') + (sel && sel.kind === 'tx' && sel.id === t.clips[j].id ? ' is-sel' : '');
            b.dataset.tx = t.clips[j].id;
            b.style.insetInlineStart = pos(jx);
            b.title = (L.tx_open || '') + ': ' + (t.clips[j].tx ? (L['tx_' + t.clips[j].tx.type] || '') : (L.tx_none || ''));
            b.setAttribute('aria-label', b.title);
            b.innerHTML = icon(t.clips[j].tx ? 'tx' : 'plus');
            trackV.appendChild(b);
        }
        if (drag && drag.kind === 'move' && drag.moved && drag.dropX != null) {
            var mk = document.createElement('div'); mk.className = 've-drop-mark';
            mk.style.insetInlineStart = (drag.dropX - 1) + 'px';
            trackV.appendChild(mk);
        }

        // надписи
        trackT.innerHTML = '';
        if (!t.texts.length) trackT.appendChild(addBtn('text', L.track_add_text));
        var lnT = lanesFor('text', t.texts, function (x) { return [x.start, x.end]; });
        sizeTrack(trackT, 'text', lnT.n, !t.texts.length);
        t.texts.forEach(function (x) {
            var e = document.createElement('div');
            e.className = 've-item ve-text' + (sel && sel.kind === 'text' && sel.id === x.id ? ' is-sel' : '');
            e.dataset.id = x.id;
            place(e, x.start, x.end);
            e.style.top = laneTop('text', lnT.byId[x.id] || 0);
            itemA11y(e, (x.text || L.text_placeholder || '') + ' · ' + fmt(x.start) + '–' + fmt(x.end));
            e.innerHTML = '<span class="ve-item-name">' + esc(x.text || L.text_placeholder || '…') + '</span>' + keyMarks(x) + '<span class="ve-grip l"></span><span class="ve-grip r"></span>';
            trackT.appendChild(e);
        });

        // наложения
        trackO.innerHTML = '';
        if (!t.overlays.length) trackO.appendChild(addBtn('overlay', L.track_add_overlay));
        var lnO = lanesFor('overlay', t.overlays, function (o) { return [o.start, o.end]; });
        sizeTrack(trackO, 'overlay', lnO.n, !t.overlays.length);
        t.overlays.forEach(function (o) {
            var e = document.createElement('div');
            e.className = 've-item ve-over' + (o.kind === 'video' ? ' is-video' : '') + (o.kind === 'video' && (o.mute || !o.hasAudio) ? ' is-muted' : '')
                + (sel && sel.kind === 'overlay' && sel.id === o.id ? ' is-sel' : '');
            e.dataset.id = o.id;
            place(e, o.start, o.end);
            e.style.top = laneTop('overlay', lnO.byId[o.id] || 0);
            itemA11y(e, (o.name || L.overlay || '') + ' · ' + fmt(o.start) + '–' + fmt(o.end));
            var orec = media.get(o.mediaId);
            var oth = orec && (orec.bitmap || (orec.thumbs && orec.thumbs[0] && orec.thumbs[0].c));
            if (oth) e.appendChild(overlayThumb(oth));
            e.insertAdjacentHTML('beforeend', (o.kind === 'video' ? '<svg class="ve-i ve-over-kind" aria-hidden="true"><use href="#ve-i-film"/></svg>' : '') + '<span class="ve-item-name">' + esc(o.name || L.overlay || '') + '</span>'
                + keyMarks(o) + '<span class="ve-grip l"></span><span class="ve-grip r"></span>');
            trackO.appendChild(e);
        });

        // звук
        trackA.innerHTML = '';
        if (!t.audio.length) trackA.appendChild(addBtn('audio', L.track_add_audio));
        function audEnd(a, k) { return a.loop ? t.itemSpan(k).end : a.start + Math.max(0, a.trimEnd - a.trimStart); }
        var lnA = lanesFor('audio', t.audio, function (a, k) { return [a.start, Math.max(audEnd(a, k), a.start + 0.1)]; });
        sizeTrack(trackA, 'audio', lnA.n, !t.audio.length);
        t.audio.forEach(function (a, k) {
            var rawEnd = audEnd(a, k);
            var e = document.createElement('div');
            e.className = 've-item ve-aud' + (a.voice ? ' is-voice' : '') + (a.mute ? ' is-muted' : '') + (sel && sel.kind === 'audio' && sel.id === a.id ? ' is-sel' : '');
            e.dataset.id = a.id;
            place(e, a.start, Math.max(rawEnd, a.start + 0.1));
            e.style.top = laneTop('audio', lnA.byId[a.id] || 0);
            itemA11y(e, (a.name || L.audio_track || '') + ' · ' + fmt(a.start));
            e.appendChild(waveCanvas(a, (Math.max(rawEnd, a.start + 0.1) - a.start) * pxPerSec));
            var marks = '';
            var seg = a.trimEnd - a.trimStart;
            if (a.loop && seg > 0.2) for (var q = a.start + seg; q < rawEnd - 0.05; q += seg) marks += '<i class="ve-aud-loop" style="inset-inline-start:' + ((q - a.start) * pxPerSec) + 'px"></i>';
            // Хвост дорожки за концом видео в файл не попадёт — показываем его приглушённым.
            if (t.duration > 0 && rawEnd > t.duration + 0.05) {
                marks += '<i class="ve-aud-over" style="inset-inline-start:' + Math.max(0, (t.duration - a.start) * pxPerSec) + 'px"></i>';
            }
            e.insertAdjacentHTML('beforeend', marks + '<span class="ve-item-name">' + (a.voice ? icon('mic') : '') + ' ' + esc(a.name) + '</span><span class="ve-grip l"></span>' + (a.loop ? '' : '<span class="ve-grip r"></span>'));
            trackA.appendChild(e);
        });

        // скрываемые области
        trackR.innerHTML = '';
        if (!project.regions.length) trackR.appendChild(addBtn('redact', L.track_add_redact));
        var lnR = lanesFor('region', project.regions, function (g) { return [g.start, g.end]; });
        sizeTrack(trackR, 'region', lnR.n, !project.regions.length);
        project.regions.forEach(function (g) {
            var el = document.createElement('div');
            el.className = 've-item ve-redact' + (sel && sel.kind === 'region' && sel.id === g.id ? ' is-sel' : '');
            el.dataset.id = g.id;
            place(el, g.start, g.end);
            el.style.top = laneTop('region', lnR.byId[g.id] || 0);
            var nmR = g.mode === 'blur' ? L.redact_blur : L.redact_pixelate;
            itemA11y(el, nmR + ' · ' + fmt(g.start) + '–' + fmt(g.end));
            var marks2 = '';
            (g.keys || []).forEach(function (k2) { marks2 += '<i class="ve-redact-key" style="inset-inline-start:' + Math.max(0, (k2.t - g.start) * pxPerSec) + 'px"></i>'; });
            el.innerHTML = '<span class="ve-item-name">' + esc(nmR) + '</span>' + marks2
                + '<span class="ve-grip l"></span><span class="ve-grip r"></span>';
            trackR.appendChild(el);
        });

        // Черта прилипания живёт, пока идёт жест (раньше — один кадр).
        var old = inner.querySelector('.ve-snapline');
        if (old) old.remove();
        if (drag && drag.snap != null) {
            var sl = document.createElement('div'); sl.className = 've-snapline';
            sl.style.insetInlineStart = pos(drag.snap);
            inner.appendChild(sl);
        }
        updatePlayhead();

        if (focusWant) { focusKey = 'id:' + focusWant; focusWant = null; }
        if (focusKey) {
            var q2 = focusKey.indexOf('id:') === 0 ? '[data-id="' + focusKey.slice(3) + '"]' : '[data-tx="' + focusKey.slice(3) + '"]';
            var nf = inner.querySelector(q2);
            if (nf) { try { nf.focus({ preventScroll: true }); } catch (e) {} }
        }
    }
    /* Щелчок по элементу ленты отдаёт ему фокус клавиатуры: pointerdown
       гасит действие по умолчанию, и фокус оставался на последней нажатой
       кнопке — Delete и S после щелчка по клипу уходили той кнопке. */
    var focusWant = null;
    function releaseFocus() {
        var a = document.activeElement;
        if (a && a !== document.body && ws.contains(a) && !(a.classList && a.classList.contains('ve-item'))) { try { a.blur(); } catch (e) {} }
    }
    function addBtn(kind, label) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 've-track-add'; b.dataset.add = kind;
        b.textContent = '+ ' + (label || '');
        return b;
    }
    function pickStep(pps) {
        var cand = [0.5, 1, 2, 5, 10, 15, 30, 60, 120, 300, 600];
        for (var i = 0; i < cand.length; i++) if (cand[i] * pps >= 60) return cand[i];
        return 1200;
    }
    function updatePlayhead() {
        head.style.insetInlineStart = pos(playhead);
        $('ve-cur').textContent = fmt(playhead);
        syncKeysForPlayhead();
    }
    /* Во время воспроизведения лента листается за ползунком (своя прокрутка
       контейнера, не страницы) — иначе на крупном масштабе он уходил за край. */
    function followPlayhead() {
        if (drag) return;
        var x = playhead * pxPerSec, vw = scroller.clientWidth || 0;
        if (!vw) return;
        if (x > scroller.scrollLeft + vw - 30 || x < scroller.scrollLeft) scroller.scrollLeft = Math.max(0, x - 40);
    }

    /* Миниатюры клипа — кадры по ВРЕМЕНИ ИСТОЧНИКА под каждым участком
       полосы: обрезанный клип показывает то, что в нём осталось. Канва
       кэшируется по всему, что меняет картинку: лента перерисовывается на
       каждом кадре протяжки, а перерисовывать при этом все миниатюры
       длинного проекта — это и были рывки (разбор 30.09). */
    var thumbCache = {};
    function thumbCanvas(c, widthPx) {
        var dpr = Math.min(2, window.devicePixelRatio || 1);
        var w = Math.max(10, Math.min(8000, Math.round(widthPx))), h = 60;
        var rec = c.kind === 'color' ? null : media.get(c.mediaId);
        var key = [c.kind, c.mediaId, c.trimStart.toFixed(3), c.trimEnd.toFixed(3), w, dpr, rec && rec.thumbs ? rec.thumbs.length : 0,
            rec && rec.peaks ? 1 : 0, c.mute ? 1 : 0, c.hasAudio ? 1 : 0, c.color, c.color2, c.tone, c.bright, c.contrast, c.sat, c.flipH ? 1 : 0, c.flipV ? 1 : 0].join('|');
        var hit = thumbCache[c.id];
        if (hit && hit.key === key) return hit.cv;
        var cv = document.createElement('canvas'); cv.className = 've-clip-thumbs';
        paintThumbs(cv, c, rec, w, h, dpr);
        thumbCache[c.id] = { key: key, cv: cv };
        return cv;
    }
    function paintThumbs(cv, c, rec, w, h, dpr) {
        cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
        var g = cv.getContext('2d');
        g.scale(dpr, dpr);
        if (c.kind === 'color') {
            var gr = g.createLinearGradient(0, 0, w * 0.35, h);
            gr.addColorStop(0, c.color || '#1e293b'); gr.addColorStop(1, c.color2 || '#0f172a');
            g.fillStyle = gr; g.fillRect(0, 0, w, h);
            return;
        }
        if (!rec) return;
        var f = C.lookFilter(c);
        if (f) g.filter = f;
        if (c.kind === 'image' && rec.bitmap) {
            var tw = Math.max(20, Math.round(h * rec.width / Math.max(1, rec.height)));
            for (var x = 0; x < w; x += tw) g.drawImage(rec.bitmap, x, 0, tw, h);
            g.filter = 'none';
            return;
        }
        var thumbs = rec.thumbs;
        if (thumbs && thumbs.length) {
            var tw2 = Math.max(20, Math.round(h * thumbs[0].c.width / Math.max(1, thumbs[0].c.height)));
            for (var x2 = 0; x2 < w; x2 += tw2) {
                var srcT = c.trimStart + ((x2 + tw2 / 2) / w) * (c.trimEnd - c.trimStart);
                var best = thumbs[0], bd = Infinity;
                for (var i = 0; i < thumbs.length; i++) { var dd = Math.abs(thumbs[i].t - srcT); if (dd < bd) { bd = dd; best = thumbs[i]; } }
                g.drawImage(best.c, x2, 0, tw2, h);
            }
        }
        g.filter = 'none';
        // Волна звука клипа — полосой внизу: по ней режут на паузах речи.
        if (rec.peaks && c.hasAudio && !c.mute) {
            var pk = rec.peaks, pps = rec.peaksPerSec || 40, span = c.trimEnd - c.trimStart, bandH = 16;
            if (!(rec.peakMax > 0)) { var mx = 0; for (var q = 0; q < pk.length; q++) if (pk[q] > mx) mx = pk[q]; rec.peakMax = mx || 1; }
            var norm1 = 1 / rec.peakMax;
            g.fillStyle = 'rgba(15,23,42,0.5)';
            g.fillRect(0, h - bandH, w, bandH);
            g.fillStyle = 'rgba(147,197,253,0.95)';
            for (var x3 = 0; x3 < w; x3++) {
                var s0 = c.trimStart + (x3 / w) * span, s1 = c.trimStart + ((x3 + 1) / w) * span;
                var i0 = Math.floor(s0 * pps), i1 = Math.max(i0 + 1, Math.floor(s1 * pps)), m = 0;
                for (var k = i0; k < i1 && k < pk.length; k++) if (pk[k] > m) m = pk[k];
                var bh = Math.max(1, Math.min(1, m * norm1) * (bandH - 2));
                g.fillRect(x3, h - 1 - bh, 1, bh);
            }
        }
    }
    /* Волна дорожки — её выбранный отрезок; при повторе — по кругу. Столбец
       канвы переводится во время по ДОЛЕ ширины: канва не шире 8000 px, и
       при крупном масштабе прежний перевод через px/с рисовал волну не того
       места (разбор 30.09). */
    var waveCache = {};
    function waveCanvas(a, widthPx) {
        var dpr = Math.min(2, window.devicePixelRatio || 1);
        var w = Math.max(10, Math.min(8000, Math.round(widthPx)));
        var rec = media.get(a.mediaId);
        var spanSec = Math.max(0.01, widthPx / pxPerSec);
        var key = [a.mediaId, a.trimStart.toFixed(3), a.trimEnd.toFixed(3), a.loop ? 1 : 0, w, dpr, spanSec.toFixed(3), rec && rec.peaks ? rec.peaks.length : 0, a.voice ? 1 : 0].join('|');
        var hit = waveCache[a.id];
        if (hit && hit.key === key) return hit.cv;
        var cv = document.createElement('canvas'); cv.className = 've-wave';
        var h = 43;
        cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
        var g = cv.getContext('2d');
        g.scale(dpr, dpr);
        if (rec && rec.peaks) {
            var pk = rec.peaks, pps = rec.peaksPerSec, seg = Math.max(0.01, a.trimEnd - a.trimStart);
            // Волна — по самому громкому месту файла: тихая запись иначе
            // рисуется ниткой, и дорожку не видно.
            if (!(rec.peakMax > 0)) { var mx = 0; for (var q = 0; q < pk.length; q++) if (pk[q] > mx) mx = pk[q]; rec.peakMax = mx || 1; }
            var norm1 = 1 / rec.peakMax, colSec = spanSec / w;
            g.fillStyle = a.voice ? 'rgba(167,243,208,0.75)' : 'rgba(221,214,254,0.75)';
            for (var x = 0; x < w; x++) {
                var tt = (x / w) * spanSec;
                if (a.loop) tt = tt % seg; else if (tt > seg) break;
                var i0 = Math.floor((a.trimStart + tt) * pps), i1 = Math.max(i0 + 1, Math.floor((a.trimStart + tt + colSec) * pps));
                var m = 0;
                for (var i = i0; i < i1 && i < pk.length; i++) if (pk[i] > m) m = pk[i];
                var bh = Math.max(1, Math.min(1, m * norm1) * (h - 6));
                g.fillRect(x, (h - bh) / 2, 1, bh);
            }
        }
        waveCache[a.id] = { key: key, cv: cv };
        return cv;
    }
    function overlayThumb(img) {
        var cv = document.createElement('canvas'); cv.className = 've-over-thumb';
        cv.width = 50; cv.height = 50;
        try {
            var iw = img.width || img.videoWidth || 1, ih = img.height || img.videoHeight || 1;
            var g = cv.getContext('2d'), k = Math.min(50 / iw, 50 / ih);
            g.drawImage(img, (50 - iw * k) / 2, (50 - ih * k) / 2, iw * k, ih * k);
        } catch (e) {}
        return cv;
    }
    /* Ромбы ключевых кадров на полоске элемента: движение видно на ленте. */
    function keyMarks(it) {
        if (!it.keys || !it.keys.length) return '';
        return it.keys.map(function (k) {
            return '<i class="ve-key-mark" style="left:' + Math.max(0, (k.t - it.start) * pxPerSec) + 'px"></i>';
        }).join('');
    }

    /* ── лента: мышь и палец ────────────────────────────────────────────── */

    /* Захват указателя — удобство, а не условие работы: он БРОСАЕТ, если
       указателя с таким id уже нет. Непойманное исключение здесь валит весь
       обработчик. */
    function capture(el, ev) { try { if (el.setPointerCapture) el.setPointerCapture(ev.pointerId); } catch (e) {} }

    /* Прилипание: к ползунку, краям клипов, началу/концу ленты и чужим краям. */
    function snapPoints(exceptId) {
        var t = tl(), pts = [0, t.duration, playhead];
        for (var i = 0; i < t.clips.length; i++) { pts.push(t.starts[i]); pts.push(t.starts[i] + t.effDur[i]); }
        project.texts.forEach(function (x) { if (x.id !== exceptId) { pts.push(x.start); pts.push(x.end); } });
        project.overlays.forEach(function (x) { if (x.id !== exceptId) { pts.push(x.start); pts.push(x.end); } });
        t.audio.forEach(function (a, k) { if (a.id !== exceptId) { var s2 = t.itemSpan(k); pts.push(s2.start); pts.push(s2.end); } });
        project.regions.forEach(function (g) { if (g.id !== exceptId) { pts.push(g.start); pts.push(g.end); } });
        return pts;
    }
    /* Конец клипа тянет за собой всё, что после него (лента сдвигается), —
       прилипать ему можно только к тому, что стоит на месте: ползунок,
       титры и закрашивания ДО него. Элементы после него едут вместе с ним. */
    function fixedPointsForClipEnd(clipEnd) {
        var pts = [playhead];
        function add(a, b) { if (a < clipEnd - 1e-3) pts.push(a); if (b < clipEnd - 1e-3) pts.push(b); }
        project.texts.forEach(function (x) { add(x.start, x.end); });
        project.overlays.forEach(function (x) { add(x.start, x.end); });
        project.regions.forEach(function (g) { add(g.start, g.end); });
        project.audio.forEach(function (a) { add(a.start, a.loop ? Infinity : a.start + Math.max(0, (a.trimEnd || 0) - (a.trimStart || 0))); });
        return pts;
    }
    function snapTo(v, pts) {
        var th = 8 / pxPerSec, best = null, bd = th;
        for (var i = 0; i < pts.length; i++) { var d = Math.abs(pts[i] - v); if (d < bd) { bd = d; best = pts[i]; } }
        return best;
    }

    on(ruler, 'pointerdown', function (ev) {
        if (busy) return;
        releaseFocus();
        seekTo(x2t(ev.clientX));
        drag = { kind: 'seek' };
        capture(ruler, ev);
        ev.preventDefault();
    });

    on(inner, 'click', function (ev) {
        var add = ev.target.closest && ev.target.closest('.ve-track-add');
        if (add) { addFromTrack(add.dataset.add); return; }
        var txb = ev.target.closest && ev.target.closest('.ve-txb');
        if (txb) { select('tx', txb.dataset.tx); showTransitionPoint(); ae('tx_open'); return; }
        if (ev.target.closest && ev.target.closest('.ve-item')) return;
        if (Date.now() < quietClickUntil) return;
        // Клик по пустому месту дорожки — перемотка и снятие выбора.
        if (ev.target === inner || (ev.target.classList && ev.target.classList.contains('ve-track'))) {
            releaseFocus();
            seekTo(x2t(ev.clientX));
            select(null);
        }
    });
    // Клавиатура на элементе ленты: Enter или пробел — выбрать.
    on(inner, 'keydown', function (ev) {
        var item = ev.target.closest && ev.target.closest('.ve-item');
        if (!item || (ev.key !== 'Enter' && ev.key !== ' ')) return;
        ev.preventDefault(); ev.stopPropagation();
        var kind = kindOfItem(item);
        select(kind, item.dataset.id);
        bringIntoView(kind, item.dataset.id);
    });
    function kindOfItem(item) {
        return item.classList.contains('ve-clip') ? 'clip' : item.classList.contains('ve-text') ? 'text'
            : item.classList.contains('ve-aud') ? 'audio' : item.classList.contains('ve-over') ? 'overlay' : 'region';
    }

    on(inner, 'pointerdown', function (ev) {
        if (busy) return;
        var item = ev.target.closest ? ev.target.closest('.ve-item') : null;
        if (!item) return;
        var id = item.dataset.id;
        var kind = kindOfItem(item);
        var wasSel = sel && sel.kind === kind && sel.id === id;
        var t0 = x2t(ev.clientX);
        focusWant = id;
        if (!wasSel) select(kind, id);
        else { try { item.focus({ preventScroll: true }); } catch (e) {} focusWant = null; }
        // На пальце первое касание только выбирает (и ставит ползунок): иначе лента не листается.
        if (ev.pointerType === 'touch' && !wasSel) { bringIntoView(kind, id, t0); return; }
        var grip = ev.target.classList && ev.target.classList.contains('ve-grip')
            ? (ev.target.classList.contains('l') ? 'L' : 'R') : null;
        var found = findSel();
        if (!found) return;
        var o = found.item;
        if (kind === 'clip') {
            drag = grip ? { kind: 'trim' + grip, id: id, t0: t0, o: copy(o), cut: 0 } : { kind: 'move', id: id, t0: t0, x0: ev.clientX, moved: false };
            if (grip === 'R') {
                var spR = tl().spanOf(found.index);
                drag.fixed = fixedPointsForClipEnd(spR ? spR.end : Infinity);
                drag.anchors = TL.anchorsOf(project.clips, overItems());
                drag.items = copy(overItems());
            }
        } else if (kind === 'audio') {
            drag = { kind: grip ? 'atrim' + grip : 'amove', id: id, t0: t0, o: copy(o) };
        } else {
            drag = { kind: grip ? 'wtrim' + grip : 'wmove', id: id, t0: t0, o: copy(o), list: kind };
        }
        drag.clickAt = t0; drag.x0 = ev.clientX;
        if (preview.isPlaying()) { preview.pause(); setPlayBtn(false); }
        capture(inner, ev);
        ev.preventDefault();
    });

    on(window, 'pointermove', function (ev) {
        if (!drag) return;
        var t = x2t(ev.clientX);
        if (drag.kind === 'seek') { seekTo(t); return; }
        var f = findSel();
        if (!f) return;
        // Порог жеста: дрожь руки при щелчке — это щелчок, а не протяжка.
        if (!drag.consumed && Math.abs(ev.clientX - drag.x0) < 4) return;
        var it = f.item, d = t - drag.t0, o = drag.o, pts;
        drag.consumed = true;
        drag.snap = null;
        if (drag.kind === 'move') {
            if (Math.abs(ev.clientX - drag.x0) > 6) drag.moved = true;
            if (drag.moved) { drag.target = dropIndex(t); drag.dropX = dropX(drag.target); scheduleTimeline(); }
            return;
        }
        if (drag.kind === 'trimR') {
            if (TL.isStill(it)) { var nd = clamp(o.trimEnd + d, 0.3, 600); it.duration = nd; it.trimStart = 0; it.trimEnd = nd; }
            else it.trimEnd = clamp(o.trimEnd + d * o.speed, o.trimStart + 0.1, o.duration);
            // Конец клипа прилипает к ползунку и к краям титров/дорожек до него.
            touch();
            var spE = tl().spanOf(f.index), snE = drag.fixed ? snapTo(spE.end, drag.fixed) : null;
            if (snE != null && Math.abs(snE - spE.end) > 1e-4) {
                var deltaOut = snE - spE.end;
                if (TL.isStill(it)) { var nd3 = clamp(it.trimEnd + deltaOut, 0.3, 600); it.duration = nd3; it.trimEnd = nd3; }
                else it.trimEnd = clamp(it.trimEnd + deltaOut * it.speed, it.trimStart + 0.1, it.duration);
                drag.snap = snE;
            }
            // Всё, что стоит после клипа, едет вместе с его концом.
            project.texts = copy(drag.items.texts); project.audio = copy(drag.items.audio);
            project.regions = copy(drag.items.regions); project.overlays = copy(drag.items.overlays);
            TL.reanchor(project.clips, overItems(), drag.anchors);
            touch();
            previewAt = tl().spanOf(f.index).end - 0.02;
            scheduleRefresh();
            return;
        }
        if (drag.kind === 'trimL') {
            var maxCut = TL.isStill(it) ? (o.trimEnd - 0.3) : (o.trimEnd - o.trimStart - 0.1) / o.speed;
            // Влево край тянется только у видео (там есть что «вернуть» из
            // источника); у фото и заставки левый край лишь укорачивает показ.
            var minCut = TL.isStill(it) ? 0 : -(o.trimStart / o.speed);
            drag.cut = clamp(d, minCut, maxCut);
            scheduleTimeline();
            // Кадр под новым началом клипа — чтобы видеть, откуда он пойдёт.
            var tmp = copy(project.clips);
            applyLeftTrim(tmp[f.index], o, drag.cut);
            var tt = TL.build(tmp, project.texts, { audio: project.audio, overlays: project.overlays });
            preview.setModel(tt, project.regions);
            preview.render(tt.spanOf(f.index).start + 0.001);
            return;
        }
        if (drag.kind === 'amove' || drag.kind === 'wmove') {
            var len = (drag.kind === 'amove') ? (o.trimEnd - o.trimStart) : (o.end - o.start);
            var ns = Math.max(0, o.start + d);
            pts = snapPoints(drag.id);
            var s1 = snapTo(ns, pts), s2 = drag.kind === 'amove' ? null : snapTo(ns + len, pts);
            if (s1 != null) { ns = s1; drag.snap = s1; } else if (s2 != null) { ns = Math.max(0, s2 - len); drag.snap = s2; }
            var shift = ns - it.start;
            it.start = ns;
            if (drag.kind === 'wmove') {
                it.end = ns + len;
                // Ключевые точки области едут ВМЕСТЕ с ней: они заданы
                // абсолютным временем, и без сдвига область поехала бы, а путь
                // остался бы на месте.
                if (it.keys) it.keys.forEach(function (k) { k.t += shift; });
            }
            touch(); scheduleRefresh();
            return;
        }
        if (drag.kind === 'atrimL') {
            var dd = clamp(d, -o.trimStart, (o.trimEnd - o.trimStart) - 0.2);
            dd = Math.max(dd, -o.start);
            it.start = o.start + dd; it.trimStart = o.trimStart + dd;
            touch(); scheduleRefresh();
            return;
        }
        if (drag.kind === 'atrimR') {
            var ne = clamp(o.trimEnd + d, o.trimStart + 0.2, o.duration);
            pts = snapPoints(drag.id);
            var sn = snapTo(o.start + (ne - o.trimStart), pts);
            if (sn != null) { ne = clamp(o.trimStart + (sn - o.start), o.trimStart + 0.2, o.duration); drag.snap = sn; }
            it.trimEnd = ne;
            touch(); scheduleRefresh();
            return;
        }
        if ((drag.kind === 'wtrimL' || drag.kind === 'wtrimR') && drag.list === 'overlay' && o.kind === 'video') {
            /* Видео поверх видео: края подрезают ЕГО отрезок (как у клипа), а не
               растягивают показ — кадров за краями отрезка в файле нет. */
            pts = snapPoints(drag.id);
            if (drag.kind === 'wtrimL') {
                var dl = clamp(d, -Math.min(o.trimStart, o.start), (o.trimEnd - o.trimStart) - 0.2);
                var snl = snapTo(o.start + dl, pts);
                if (snl != null) { var dsn = snl - o.start; if (dsn >= -Math.min(o.trimStart, o.start) && dsn <= (o.trimEnd - o.trimStart) - 0.2) { dl = dsn; drag.snap = snl; } }
                it.start = o.start + dl; it.trimStart = o.trimStart + dl;
            } else {
                var dr = clamp(d, -((o.trimEnd - o.trimStart) - 0.2), (o.duration || o.trimEnd) - o.trimEnd);
                var snr = snapTo(o.end + dr, pts);
                if (snr != null) { var dsr = snr - o.end; if (dsr >= -((o.trimEnd - o.trimStart) - 0.2) && dsr <= (o.duration || o.trimEnd) - o.trimEnd) { dr = dsr; drag.snap = snr; } }
                it.trimEnd = o.trimEnd + dr;
            }
            it.end = it.start + (it.trimEnd - it.trimStart);
            touch(); scheduleRefresh();
            return;
        }
        if (drag.kind === 'wtrimL' || drag.kind === 'wtrimR') {
            pts = snapPoints(drag.id);
            if (drag.kind === 'wtrimL') {
                var s3 = clamp(o.start + d, 0, o.end - 0.2), sn3 = snapTo(s3, pts);
                if (sn3 != null && sn3 < o.end - 0.2) { s3 = sn3; drag.snap = sn3; }
                it.start = s3;
            } else {
                var e3 = Math.max(o.start + 0.2, o.end + d), sn4 = snapTo(e3, pts);
                if (sn4 != null && sn4 > o.start + 0.2) { e3 = sn4; drag.snap = sn4; }
                it.end = e3;
            }
            touch(); scheduleRefresh();
        }
    });

    /* Щелчок, которым кончается перетаскивание, — не «щелчок по ленте»:
       элемент под пальцем перерисован, и событие достаётся самой ленте, где
       оно значило бы «перемотать сюда и снять выбор». */
    var quietClickUntil = 0;
    on(window, 'pointerup', function () {
        if (!drag) return;
        var dg = drag;
        drag = null;
        previewAt = null;
        if (dg.consumed) quietClickUntil = Date.now() + 350;
        if (dg.kind === 'seek') return;
        if (!dg.consumed) {
            // Простой щелчок по элементу: ползунок — туда, где щёлкнули, чтобы
            // выбранное было видно в превью.
            if (sel && dg.clickAt != null) bringIntoView(sel.kind, sel.id, dg.clickAt);
            renderTimeline();
            return;
        }
        if (dg.kind === 'move') {
            if (dg.moved && dg.target != null) {
                var f = findSel();
                if (f && dg.target !== f.index) {
                    var to = dg.target > f.index ? dg.target - 1 : dg.target;
                    editMain(null, function () { project.clips = TL.move(project.clips, f.index, to); tidyTransitions(); });
                    ae('clip_moved');
                }
            }
            touch(); refresh(); commit();
            return;
        }
        if (dg.kind === 'trimL') {
            // Левая обрезка ложится в модель только сейчас — до отпускания
            // двигался один край, а не вся лента под пальцем.
            var fl = findSel();
            if (fl && dg.cut) editMain(null, function () { applyLeftTrim(fl.item, dg.o, dg.cut); });
        }
        touch(); refresh(); commit();
        if (dg.kind === 'trimL' || dg.kind === 'trimR') ae('clip_trimmed');
    });
    /* Жест отменён системой (прокрутка, звонок): всё возвращается как было
       до него — без записи в историю и без полуприменённой обрезки. */
    on(window, 'pointercancel', function () {
        if (canvasDrag) { canvasDrag = null; canvas.classList.remove('is-dragging'); }
        if (!drag) return;
        var dg = drag; drag = null; previewAt = null;
        if (dg.consumed && hist.idx >= 0) restore(hist.stack[hist.idx]);
        else { touch(); refresh(); }
    });

    /** Левая обрезка на `cut` секунд ЛЕНТЫ: видео — от источника, фото и заставка — от длины. */
    function applyLeftTrim(it, o, cut) {
        if (TL.isStill(it)) {
            var nd = Math.max(0.3, o.trimEnd - cut);
            it.duration = nd; it.trimStart = 0; it.trimEnd = nd;
        } else {
            it.trimStart = clamp(o.trimStart + cut * o.speed, 0, o.trimEnd - 0.1);
        }
    }

    var tlRaf = 0;
    function scheduleTimeline() {
        if (tlRaf) return;
        tlRaf = requestAnimationFrame(function () { tlRaf = 0; renderTimeline(); });
    }

    /** Куда встанет перетаскиваемый клип: индекс «перед каким» (0..n). */
    function dropIndex(sec) {
        var t = tl();
        for (var i = 0; i < t.clips.length; i++) {
            var sp = t.spanOf(i);
            if (sec < sp.start + (sp.end - sp.start) / 2) return i;
        }
        return t.clips.length;
    }
    function dropX(idx) {
        var t = tl();
        if (idx >= t.clips.length) return t.duration * pxPerSec;
        return t.starts[idx] * pxPerSec;
    }

    /* Перемотка. Во время воспроизведения — часы превью на новое место
       (раньше стрелки и Home/End при пуске не делали ничего). */
    function seekTo(t) {
        playhead = clamp(t, 0, Math.max(0, tl().duration));
        updatePlayhead();
        if (preview.isPlaying()) preview.seek(playhead);
        else preview.render(playhead);
    }
    function frameStep() { var g = chooseTarget(tl()); return 1 / (g.fps || 30); }

    /* ── превью: выделение, безопасные зоны и перетаскивание по кадру ─────── */
    function drawSelection(ctx2, W, H, t) {
        if (safeZones) drawSafeZones(ctx2, W, H);
        if (!sel) return;
        if (sel.kind === 'region') {
            var vis = RD ? RD.at(project.regions, t) : [];
            var idx = -1;
            project.regions.forEach(function (g, i) { if (g.id === sel.id) idx = i; });
            if (vis.length) RD.outline(ctx2, vis, W, H, idx);
            return;
        }
        var f = findSel();
        if (!f) return;
        if (sel.kind === 'text' && OV) {
            var nt = keyedText(f.item, t);
            if (t < nt.start || t > nt.end || !String(nt.text).trim()) return;
            var b = OV.boxOf(ctx2, nt, W, H);
            outlineBox(ctx2, b.x - b.pad * 0.6, b.y - b.pad * 0.4, b.w + b.pad * 1.2, b.h + b.pad * 0.8, W, 'rgba(52,211,153,0.95)', false);
        } else if (sel.kind === 'overlay') {
            var no = keyedOverlay(f.item, t);
            if (t < no.start || t > no.end) return;
            var ob = C.overlayBox(no, W, H);
            outlineBox(ctx2, ob.x, ob.y, ob.w, ob.h, W, 'rgba(34,211,238,0.95)', true);
        }
    }
    /* Элемент в момент t с учётом ключевых кадров — то, что сейчас на экране:
       по нему рисуется рамка выделения и считается, за что тянут. */
    function keyedText(it, t) {
        var nt = TL._normText(it, 0), v = TL.valuesAt('text', it, t);
        nt.x = v.x; nt.y = v.y; nt.sizePct = v.s;
        return nt;
    }
    function keyedOverlay(it, t) {
        var no = TL._normOverlay(it, 0), v = TL.valuesAt('overlay', it, t);
        no.x = v.x; no.y = v.y; no.w = v.w; no.opacity = v.o;
        return no;
    }
    function outlineBox(ctx2, x, y, w, h, W, color, corner) {
        ctx2.save();
        ctx2.setLineDash([Math.max(4, W / 160), Math.max(3, W / 240)]);
        ctx2.strokeStyle = color;
        ctx2.lineWidth = Math.max(1.5, W / 400);
        ctx2.strokeRect(x, y, w, h);
        if (corner) {
            var s = Math.max(8, W / 60);
            ctx2.setLineDash([]);
            ctx2.fillStyle = color;
            ctx2.fillRect(x + w - s, y + h - s, s, s);
        }
        ctx2.restore();
    }
    /* Безопасные зоны: где интерфейс площадки (подпись, кнопки) закроет кадр.
       Только превью — в файл не попадает. У вертикали (Reels, Shorts, TikTok)
       снизу подпись и справа кнопки; у остальных — поля 5 %. */
    function drawSafeZones(ctx2, W, H) {
        var vert = H > W * 1.2;
        var x0 = W * 0.05, y0 = H * (vert ? 0.12 : 0.05), x1 = W * (vert ? 0.84 : 0.95), y1 = H * (vert ? 0.78 : 0.95);
        ctx2.save();
        ctx2.fillStyle = 'rgba(239,68,68,0.16)';
        ctx2.fillRect(0, 0, W, y0); ctx2.fillRect(0, y1, W, H - y1);
        ctx2.fillRect(0, y0, x0, y1 - y0); ctx2.fillRect(x1, y0, W - x1, y1 - y0);
        ctx2.setLineDash([Math.max(4, W / 120), Math.max(3, W / 180)]);
        ctx2.strokeStyle = 'rgba(255,255,255,0.7)';
        ctx2.lineWidth = Math.max(1, W / 480);
        ctx2.strokeRect(x0, y0, x1 - x0, y1 - y0);
        ctx2.restore();
    }

    var canvasDrag = null;
    function canvasPoint(ev) {
        var r = canvas.getBoundingClientRect();
        return { x: (ev.clientX - r.left) / r.width, y: (ev.clientY - r.top) / r.height };
    }
    function textAtPoint(pt) {
        var ctx2 = canvas.getContext('2d'), W = canvas.width, H = canvas.height;
        var vis = tl().textsAt(playhead);
        for (var i = vis.length - 1; i >= 0; i--) {
            var b = OV.boxOf(ctx2, vis[i].item, W, H);
            var px = pt.x * W, py = pt.y * H;
            if (px >= b.x - b.pad && px <= b.x + b.w + b.pad && py >= b.y - b.pad && py <= b.y + b.h + b.pad) return vis[i].item.id;
        }
        return null;
    }
    function overlayAtPoint(pt) {
        var W = canvas.width, H = canvas.height, vis = tl().overlaysAt(playhead);
        for (var i = vis.length - 1; i >= 0; i--) {
            var b = C.overlayBox(vis[i].item, W, H), px = pt.x * W, py = pt.y * H;
            if (px >= b.x && px <= b.x + b.w && py >= b.y && py <= b.y + b.h) return vis[i].item.id;
        }
        return null;
    }
    function regionAtPoint(pt) {
        var vis = RD ? RD.at(project.regions, playhead) : [];
        for (var i = vis.length - 1; i >= 0; i--) {
            var r = vis[i].rect;
            if (pt.x >= r.x && pt.x <= r.x + r.w && pt.y >= r.y && pt.y <= r.y + r.h) return project.regions[vis[i].index].id;
        }
        return null;
    }
    on(canvas, 'pointerdown', function (ev) {
        if (busy) return;
        releaseFocus();
        var pt = canvasPoint(ev);
        if (isFull()) { canvasDrag = { kind: 'tap', px: pt.x, py: pt.y }; return; }
        if (preview.isPlaying()) { preview.pause(); setPlayBtn(false); }
        var hitT = textAtPoint(pt), hitO = hitT ? null : overlayAtPoint(pt), hitR = (hitT || hitO) ? null : regionAtPoint(pt);
        if (hitT && !(sel && sel.kind === 'text' && sel.id === hitT)) select('text', hitT);
        else if (hitO && !(sel && sel.kind === 'overlay' && sel.id === hitO)) select('overlay', hitO);
        else if (hitR && !(sel && sel.kind === 'region' && sel.id === hitR)) select('region', hitR);
        var f = findSel();
        if (sel && sel.kind === 'region' && f) {
            var r = RD.rectAt(f.item, playhead);
            if (!r) return;
            // Правый нижний угол — растягивание, остальное — перенос. Уголок с
            // запасом: пальцем в 8 экранных пикселей не попасть.
            var grab = 0.06;
            var onCorner = (pt.x > r.x + r.w - grab) && (pt.y > r.y + r.h - grab);
            canvasDrag = { kind: onCorner ? 'rsize' : 'rmove', px: pt.x, py: pt.y, r0: r };
        } else if (sel && sel.kind === 'text' && f) {
            var vt = TL.valuesAt('text', f.item, playhead);
            canvasDrag = { kind: 'text', px: pt.x, py: pt.y, x0: vt.x, y0: vt.y };
        } else if (sel && sel.kind === 'overlay' && f) {
            var W = canvas.width, H = canvas.height, kov = keyedOverlay(f.item, playhead), ob = C.overlayBox(kov, W, H);
            var cornerO = (pt.x * W > ob.x + ob.w - Math.max(14, W * 0.04)) && (pt.y * H > ob.y + ob.h - Math.max(14, W * 0.04));
            if (!(pt.x * W >= ob.x && pt.x * W <= ob.x + ob.w && pt.y * H >= ob.y && pt.y * H <= ob.y + ob.h)) return;
            canvasDrag = { kind: cornerO ? 'osize' : 'omove', px: pt.x, py: pt.y, x0: kov.x, y0: kov.y, w0: kov.w, cx: ob.x / W };
        } else if (sel && sel.kind === 'clip' && f && panRoom(f.item) && onScreen(f.index)) {
            canvasDrag = { kind: 'pan', px: pt.x, py: pt.y, x0: f.item.panX || 0, y0: f.item.panY || 0, room: panRoom(f.item) };
        } else return;
        canvas.classList.add('is-dragging');
        capture(canvas, ev);
        ev.preventDefault();
    });
    on(canvas, 'pointermove', function (ev) {
        if (!canvasDrag || canvasDrag.kind === 'tap') return;
        var f = findSel();
        if (!f) return;
        var pt = canvasPoint(ev);
        /* Титр и наложение с движением (ключевыми кадрами) правят ключ в этом
           кадре, без движения — своё место (TL.setValuesAt). */
        if (canvasDrag.kind === 'text') {
            TL.setValuesAt('text', f.item, playhead, { x: clamp(canvasDrag.x0 + (pt.x - canvasDrag.px), 0, 1),
                y: clamp(canvasDrag.y0 + (pt.y - canvasDrag.py), 0, 1) });
        } else if (canvasDrag.kind === 'omove') {
            TL.setValuesAt('overlay', f.item, playhead, { x: clamp(canvasDrag.x0 + (pt.x - canvasDrag.px), 0, 1),
                y: clamp(canvasDrag.y0 + (pt.y - canvasDrag.py), 0, 1) });
        } else if (canvasDrag.kind === 'osize') {
            // Угол тянет ширину; левый край стоит на месте.
            var nw = clamp(canvasDrag.w0 + (pt.x - canvasDrag.px), 0.03, 1);
            TL.setValuesAt('overlay', f.item, playhead, { w: nw, x: clamp(canvasDrag.cx + nw / 2, 0, 1) });
            syncOverlayUi(f.item);
        } else if (canvasDrag.kind === 'pan') {
            // Тянут картинку: вправо — видно больше левой части кадра.
            var rm = canvasDrag.room;
            if (rm.x > 0) f.item.panX = clamp(canvasDrag.x0 - 2 * (pt.x - canvasDrag.px) / rm.x, -1, 1);
            if (rm.y > 0) f.item.panY = clamp(canvasDrag.y0 - 2 * (pt.y - canvasDrag.py) / rm.y, -1, 1);
            syncPanUi(f.item);
        } else {
            /* Перенос и растягивание области правят БЛИЖАЙШУЮ ключевую точку, а
               не саму область: положение хранится только в точках, и «подвинуть
               область» иначе стёрло бы путь, который человек уже задал. */
            var k = nearestKey(f.item, playhead);
            if (!k) return;
            if (canvasDrag.kind === 'rmove') {
                k.x = clamp(canvasDrag.r0.x + (pt.x - canvasDrag.px), 0, 1 - k.w);
                k.y = clamp(canvasDrag.r0.y + (pt.y - canvasDrag.py), 0, 1 - k.h);
            } else {
                k.w = clamp(canvasDrag.r0.w + (pt.x - canvasDrag.px), 0.02, 1 - k.x);
                k.h = clamp(canvasDrag.r0.h + (pt.y - canvasDrag.py), 0.02, 1 - k.y);
            }
        }
        canvasDrag.moved = true;
        touch();
        preview.setModel(tl(), project.regions);
        preview.render(playhead);
    });
    on(window, 'pointerup', function () {
        if (!canvasDrag) return;
        var cd = canvasDrag;
        canvasDrag = null;
        canvas.classList.remove('is-dragging');
        // Во весь экран касание кадра — пуск и пауза, как у плеера.
        if (cd.kind === 'tap') { togglePlay(); return; }
        if (cd.kind === 'pan') ae('clip_pan');
        if (cd.kind === 'omove' || cd.kind === 'osize') ae('overlay_' + cd.kind);
        if (cd.moved) { if (cd.kind === 'text' || cd.kind === 'omove' || cd.kind === 'osize') refresh(); commit(); }
    });
    /* Сколько картинки клипа «лишнее» по ширине и высоте (в долях кадра) при
       заполнении или масштабе: столько и можно сдвигать. Ноль — нечего. */
    function panRoom(c) {
        if (!c || c.kind === 'color') return null;
        var rec = media.get(c.mediaId);
        var w = (rec && rec.width) || c.width, h = (rec && rec.height) || c.height;
        if (!(w > 0 && h > 0)) return null;
        var room = C.overflowOf({ width: w, height: h }, TL._normClip(c, 0), canvas.width, canvas.height);
        return (room && (room.x > 0.01 || room.y > 0.01)) ? room : null;
    }
    /** Клип i сейчас в кадре превью (иначе тянули бы невидимую картинку). */
    function onScreen(i) {
        var fr = tl().frameAt(playhead);
        return !!fr && (fr.a.index === i || (!!fr.b && fr.b.index === i));
    }
    function syncPanUi(c) {
        var box = $('ve-pan-row');
        if (!box) return;
        var can = !!panRoom(c);
        box.hidden = !can;
        $('ve-pan-reset').disabled = !(Math.abs(c.panX || 0) > 1e-3 || Math.abs(c.panY || 0) > 1e-3);
        canvas.classList.toggle('can-pan', can && !!sel && sel.kind === 'clip');
    }
    on($('ve-pan-reset'), 'click', function () {
        var f = findSel(); if (!f || sel.kind !== 'clip') return;
        f.item.panX = 0; f.item.panY = 0;
        touch(); refresh(); commit();
        ae('clip_pan_reset');
    });

    function nearestKey(g, t) {
        if (!g.keys || !g.keys.length) return null;
        var best = g.keys[0], bd = Math.abs(g.keys[0].t - t);
        for (var i = 1; i < g.keys.length; i++) { var d = Math.abs(g.keys[i].t - t); if (d < bd) { bd = d; best = g.keys[i]; } }
        return best;
    }

    /* ── воспроизведение ────────────────────────────────────────────────── */
    var playBtn = $('ve-play');
    function setPlayBtn(p) {
        var rec = playBtn.classList.contains('is-rec');
        var ic = rec ? 'stop' : (p ? 'pause' : 'play');
        var lab = rec ? (L.voice_stop || 'Stop') : (p ? (L.pause || 'Pause') : (L.play || 'Play'));
        playBtn.innerHTML = icon(ic);
        playBtn.setAttribute('aria-label', lab);
        playBtn.title = lab;
    }
    function togglePlay() {
        if (busy) return;
        demoStop = null;
        if (preview.isPlaying()) { preview.pause(); setPlayBtn(false); preview.render(playhead); return; }
        if (!(tl().duration > 0)) return;
        preview.setModel(tl(), project.regions);
        preview.play(playhead);
        setPlayBtn(true);
        ae('preview_play');
    }
    on(playBtn, 'click', function () { if (VO && VO.isRecording()) { VO.finish(); return; } togglePlay(); });
    on($('ve-home'), 'click', function () { seekTo(0); });
    on($('ve-end'), 'click', function () { seekTo(tl().duration); });
    on($('ve-prev'), 'click', function () { seekTo(playhead - frameStep()); });
    on($('ve-next'), 'click', function () { seekTo(playhead + frameStep()); });

    /* Во весь экран — сцена целиком (канва вписывается в экран). Касание кадра
       там — пуск и пауза; Esc возвращает. На iPhone элемент развернуть нельзя —
       кнопки там нет. */
    var stageEl = $('ve-stage'), fullBtn = $('ve-full');
    function isFull() { return (document.fullscreenElement || document.webkitFullscreenElement) === stageEl; }
    if (!(document.fullscreenEnabled || document.webkitFullscreenEnabled) || !(stageEl.requestFullscreen || stageEl.webkitRequestFullscreen)) fullBtn.hidden = true;
    on(fullBtn, 'click', function () {
        try {
            if (isFull()) { (document.exitFullscreen || document.webkitExitFullscreen).call(document); return; }
            var p = (stageEl.requestFullscreen || stageEl.webkitRequestFullscreen).call(stageEl);
            if (p && p.catch) p.catch(function () {});
            ae('fullscreen');
        } catch (e) {}
    });
    on($('ve-safe'), 'click', function () {
        safeZones = !safeZones;
        this.setAttribute('aria-pressed', safeZones ? 'true' : 'false');
        try { window.__toolSettings && window.__toolSettings.save(SLUG, 'safe', safeZones ? 1 : 0); } catch (e) {}
        if (!preview.isPlaying()) preview.render(playhead);
        ae('safe_zones', { on: safeZones ? 1 : 0 });
    });
    try {
        if (window.__toolSettings && +window.__toolSettings.load(SLUG, 'safe', 0) === 1) { safeZones = true; $('ve-safe').setAttribute('aria-pressed', 'true'); }
    } catch (e) {}

    /* ── инспектор ──────────────────────────────────────────────────────── */
    var PANES = { clip: 've-insp-clip', tx: 've-insp-tx', text: 've-insp-text', audio: 've-insp-audio', region: 've-insp-region', voice: 've-insp-voice', overlay: 've-insp-overlay' };
    function paneOf() {
        if (!sel) return null;
        if (sel.kind === 'voice') return 'voice';
        return findSel() ? sel.kind : null;
    }
    function setSeg(scope, name, value) {
        var seg = scope.querySelector('[data-seg="' + name + '"]');
        if (!seg) return;
        var bs = seg.querySelectorAll('[data-v]');
        for (var i = 0; i < bs.length; i++) bs[i].classList.toggle('on', bs[i].getAttribute('data-v') === String(value));
    }
    function setTab(name) {
        clipTab = name;
        var tabs = $('ve-clip-tabs').querySelectorAll('[data-tab]');
        for (var i = 0; i < tabs.length; i++) {
            var onT = tabs[i].getAttribute('data-tab') === name;
            tabs[i].classList.toggle('on', onT);
            tabs[i].setAttribute('aria-selected', onT ? 'true' : 'false');
        }
        ['frame', 'look', 'time'].forEach(function (p) { $('ve-tab-' + p).hidden = p !== name; });
        if (name === 'look') scheduleFilterThumbs();
    }
    on($('ve-clip-tabs'), 'click', function (ev) {
        var b = ev.target.closest('[data-tab]');
        if (!b || b.hidden) return;
        setTab(b.getAttribute('data-tab'));
        ae('clip_tab', { t: clipTab });
    });
    function stageHint(text) { $('ve-stage-hint').textContent = text || ''; }

    function syncInspector() {
        var pane = paneOf();
        canvas.classList.remove('can-pan');
        $('ve-insp-none').hidden = !!pane;
        Object.keys(PANES).forEach(function (k) { $(PANES[k]).hidden = (k !== pane); });
        stageHint(pane === 'text' ? L.hint_text_drag : pane === 'overlay' ? L.hint_overlay_drag : pane === 'region' ? L.hint_region_drag : '');
        if (!pane || pane === 'voice') return;
        var f = findSel(), it = f.item, box = $(PANES[pane]);
        if (pane === 'clip') syncClipPane(it, f.index, box);
        else if (pane === 'tx') {
            var tx = it.tx;
            var chips = $('ve-tx-types').querySelectorAll('[data-tx]');
            for (var i = 0; i < chips.length; i++) chips[i].classList.toggle('on', chips[i].getAttribute('data-tx') === (tx ? tx.type : 'none'));
            $('ve-tx-dur-row').hidden = !tx;
            if (tx) { $('ve-tx-dur').value = tx.dur; $('ve-tx-dur-v').textContent = secLabel(tx.dur); }
            var t = tl(), ov = t.overlaps[f.index] || 0;
            // Переход укорочен соседями — но не «убран»: у убранного и строки нет.
            $('ve-tx-short').hidden = !(tx && ov > 0 && ov + 0.05 < tx.dur);
        } else if (pane === 'text') {
            if (document.activeElement !== $('ve-text-content')) $('ve-text-content').value = it.text || '';
            var tsz = TL.valuesAt('text', it, playhead).s;
            $('ve-text-size').value = tsz; $('ve-text-size-v').textContent = nfmt(tsz, tsz % 1 ? 1 : 0) + '%';
            $('ve-text-color').value = it.color || '#ffffff';
            $('ve-text-bgcolor').value = it.bgColor || '#000000';
            $('ve-text-bgcolor').hidden = (it.bg || 'shadow') === 'none';
            $('ve-text-font').value = it.font || 'sans';
            $('ve-text-anim').value = it.anim || 'fade';
            setSeg(box, 'align', it.align || 'center');
            setSeg(box, 'bg', it.bg || 'shadow');
            setSeg(box, 'tpos', '');
            renderStyles(it);
            syncKeysUi('text', it);
        } else if (pane === 'audio') {
            $('ve-aud-title').textContent = it.name || L.audio_track;
            $('ve-aud-ico').setAttribute('href', '#ve-i-' + (it.voice ? 'mic' : 'music'));
            $('ve-aud-vol').value = Math.round(it.volume * 100); $('ve-aud-vol-v').textContent = pct(it.volume);
            $('ve-aud-mute').checked = !!it.mute;
            $('ve-afade-in').value = it.fadeIn || 0; $('ve-afade-in-v').textContent = secLabel(it.fadeIn || 0);
            $('ve-afade-out').value = it.fadeOut || 0; $('ve-afade-out-v').textContent = secLabel(it.fadeOut || 0);
            $('ve-aud-loop').checked = !!it.loop;
            $('ve-aud-duck').checked = !!it.duck;
            // Дубль голоса — не музыка: ни повтора, ни «тише под речью», ни подсказки про музыку.
            $('ve-aud-music').hidden = !!it.voice;
            $('ve-aud-hint').hidden = !!it.voice;
        } else if (pane === 'overlay') {
            var isVidO = it.kind === 'video';
            $('ve-ov-title').textContent = it.name || L.overlay;
            var ovIco = box.querySelector('.ve-insp-head use');
            if (ovIco) ovIco.setAttribute('href', '#ve-i-' + (isVidO ? 'pip' : 'layers'));
            $('ve-ov-sound').hidden = !isVidO;
            if (isVidO) {
                var noAo = it.hasAudio === false;
                $('ve-ov-noaudio').hidden = !noAo;
                $('ve-ov-sound').querySelector('.ve-row').hidden = noAo;
                var ovv = it.volume == null ? 1 : it.volume;
                $('ve-ov-vol').value = Math.round(ovv * 100); $('ve-ov-vol-v').textContent = pct(ovv);
                $('ve-ov-mute').checked = !!it.mute;
            }
            // «На всё видео» у видео-наложения нет: его длина — его отрезок.
            $('ve-ov-full').hidden = isVidO;
            syncOverlayUi(it);
            setSeg(box, 'ovanim', it.anim || 'fade');
            setSeg(box, 'ovpos', '');
            setSeg(box, 'ovshape', it.shape || 'rect');
            setSeg(box, 'ovborder', it.border || 'none');
            var ck = it.chroma;
            $('ve-ov-chroma').checked = !!ck;
            $('ve-ov-chroma-set').hidden = !ck;
            if (ck) {
                var kc = String(ck.color || '#00ff00').toLowerCase();
                setSeg(box, 'chroma', kc === '#00ff00' || kc === '#0000ff' ? kc : '');
                $('ve-ov-chroma-color').value = kc;
                var sim = Math.round((ck.sim == null ? 0.3 : ck.sim) * 100), smo = Math.round((ck.smooth == null ? 0.08 : ck.smooth) * 100);
                $('ve-ov-chroma-sim').value = sim; $('ve-ov-chroma-sim-v').textContent = String(sim);
                $('ve-ov-chroma-smooth').value = smo; $('ve-ov-chroma-smooth-v').textContent = String(smo);
            }
            syncKeysUi('overlay', it);
        } else if (pane === 'region') {
            setSeg(box, 'rmode', it.mode || 'pixelate');
            $('ve-redact-strength').value = it.strength; $('ve-redact-strength-v').textContent = String(it.strength);
            $('ve-redact-keys').textContent = String((it.keys || []).length);
        }
    }
    /* Размер и непрозрачность — те, что в этом кадре (с ключами они меняются по ходу). */
    function syncOverlayUi(it) {
        var v = TL.valuesAt('overlay', it, playhead);
        $('ve-ov-size').value = Math.round(v.w * 100); $('ve-ov-size-v').textContent = pct(v.w);
        $('ve-ov-opacity').value = Math.round(Math.max(0.05, v.o) * 100); $('ve-ov-opacity-v').textContent = pct(v.o);
    }
    /* Блок ключевых кадров титра и наложения: сколько ключей, стоит ли ключ в
       этом кадре, есть ли куда листать. Зовётся и при движении ползунка. */
    function syncKeysUi(kind, it) {
        var host = document.querySelector('.ve-keys[data-keys="' + kind + '"]');
        if (!host) return;
        var keys = it.keys || [], here = TL.keyNear(it, playhead);
        host.querySelector('.ve-keys-n').textContent = String(keys.length);
        var tg = host.querySelector('[data-key-act="toggle"]');
        tg.setAttribute('aria-pressed', here ? 'true' : 'false');
        host.querySelector('.ve-key-l').textContent = here ? (L.key_remove || '') : (L.key_add || '');
        var prevB = host.querySelector('[data-key-act="prev"]'), nextB = host.querySelector('[data-key-act="next"]');
        prevB.disabled = !keys.some(function (k) { return k.t < playhead - TL.KEY_SNAP; });
        nextB.disabled = !keys.some(function (k) { return k.t > playhead + TL.KEY_SNAP; });
        var seg = host.querySelector('[data-seg="ease"]');
        seg.hidden = keys.length < 2;
        setSeg(host, 'ease', it.ease === 'linear' ? 'linear' : 'smooth');
    }
    /* Ползунок поехал — у выбранного титра или наложения меняются «ключ здесь»
       и значения в инспекторе. На воспроизведении — не чаще 4 раз в секунду. */
    var keysUiAt = 0;
    function syncKeysForPlayhead() {
        if (!sel || (sel.kind !== 'text' && sel.kind !== 'overlay')) return;
        var now = Date.now();
        if (preview.isPlaying() && now - keysUiAt < 250) return;
        keysUiAt = now;
        var f = findSel();
        if (!f) return;
        if (sel.kind === 'overlay') syncOverlayUi(f.item);
        else { var tsz2 = TL.valuesAt('text', f.item, playhead).s; $('ve-text-size').value = tsz2; $('ve-text-size-v').textContent = nfmt(tsz2, tsz2 % 1 ? 1 : 0) + '%'; }
        syncKeysUi(sel.kind, f.item);
    }
    function syncClipPane(it, index, box) {
        var isVideo = it.kind === 'video', isImg = it.kind === 'image', isCard = it.kind === 'color';
        $('ve-clip-title').textContent = isCard ? (L.card || '') : (it.name || (isImg ? L.photo : L.clip));
        $('ve-clip-ico').setAttribute('href', '#ve-i-' + (isCard ? 'card' : isImg ? 'image' : 'film'));
        $('ve-freeze').hidden = !isVideo;
        $('ve-make-pip').hidden = isCard || project.clips.length < 2;
        $('ve-rev-row').hidden = !isVideo;
        if (isVideo) {
            var revd = !!it.reverseOf;
            $('ve-reverse').setAttribute('aria-pressed', revd ? 'true' : 'false');
            $('ve-reverse-l').textContent = revd ? (L.reverse_off || '') : (L.reverse || '');
            $('ve-reverse').disabled = !!reversing;
        }
        // Вкладки: у заставки нет «Цвета» (её цвет — в «Кадре»), у фото и
        // заставки третья вкладка — «Время», а не «Звук».
        $('ve-tab-look-b').hidden = isCard;
        $('ve-tab-time-b').textContent = isVideo ? (L.tab_sound || '') : (L.tab_time || '');
        if (isCard && clipTab === 'look') clipTab = 'frame';
        setTab(clipTab);

        // Кадр
        $('ve-card-row').hidden = !isCard;
        $('ve-card-text-row').hidden = !isCard;
        $('ve-fit-row').hidden = isCard;
        $('ve-zoom-row').hidden = isCard;
        $('ve-rot-row').hidden = isCard;
        $('ve-motion-row').hidden = !isImg;
        $('ve-frame-all').hidden = isCard || project.clips.filter(function (c) { return c.kind !== 'color'; }).length < 2;
        if (isCard) renderSwatches($('ve-card-colors'), CARD_PRESETS.map(function (p) { return p[0]; }), it.color, 'card', CARD_PRESETS);
        else {
            setSeg(box, 'fit', it.fit || 'contain');
            $('ve-bg-row').hidden = (it.fit || 'contain') !== 'contain';
            renderSwatches($('ve-bg-colors'), BG_COLORS, it.bgColor || '#000000', 'bg');
            var z = it.zoom || 1;
            $('ve-czoom').value = Math.round(z * 100); $('ve-czoom-v').textContent = pct(z);
            setSeg(box, 'rotation', it.rotation || 0);
            $('ve-flip-h').setAttribute('aria-pressed', it.flipH ? 'true' : 'false');
            $('ve-flip-v').setAttribute('aria-pressed', it.flipV ? 'true' : 'false');
            if (isImg) setSeg(box, 'motion', it.motion || 'none');
            syncPanUi(it);
            if (panRoom(it)) stageHint(L.hint_pan);
        }
        // Цвет
        if (!isCard) syncLook(it);
        // Время / звук
        $('ve-speed-row').hidden = !isVideo;
        $('ve-img-dur-row').hidden = isVideo;
        if (isVideo) {
            $('ve-speed').value = it.speed; $('ve-speed-v').textContent = nfmt(it.speed, 2) + '×';
            var chips = $('ve-speed-chips').querySelectorAll('[data-speed]');
            for (var i = 0; i < chips.length; i++) chips[i].classList.toggle('on', Math.abs(+chips[i].getAttribute('data-speed') - it.speed) < 1e-3);
            $('ve-volume').value = Math.round(it.volume * 100); $('ve-volume-v').textContent = pct(it.volume);
            $('ve-mute').checked = !!it.mute;
        } else {
            var dur = it.trimEnd - it.trimStart;
            var r = $('ve-img-dur');
            // Край на ленте даёт до 600 с — ползунок растёт за длиной, а не
            // режет её до своего потолка при первом касании (разбор 30.09).
            r.max = String(Math.max(30, Math.ceil(dur)));
            r.value = dur; $('ve-img-dur-v').textContent = secLabel(dur);
        }
        var noA = isVideo && it.hasAudio === false;
        $('ve-clip-noaudio').hidden = !noA;
        $('ve-clip-audio-rows').hidden = !isVideo || noA;
        $('ve-detach').hidden = !isVideo || noA || it.mute;
        $('ve-cfade-in').value = it.fadeIn || 0; $('ve-cfade-in-v').textContent = secLabel(it.fadeIn || 0);
        $('ve-cfade-out').value = it.fadeOut || 0; $('ve-cfade-out-v').textContent = secLabel(it.fadeOut || 0);
    }
    function renderSwatches(host, colors, current, target, pairs) {
        var cur = String(current || '').toLowerCase();
        var html = colors.map(function (c, i) {
            var bg = pairs ? 'linear-gradient(135deg,' + pairs[i][0] + ',' + pairs[i][1] + ')' : c;
            return '<button type="button" class="ve-sw' + (c.toLowerCase() === cur ? ' on' : '') + '" data-sw="' + c + '" data-i="' + i + '" style="background:' + bg + '" aria-label="' + esc(c) + '"></button>';
        }).join('');
        var custom = colors.map(function (c) { return c.toLowerCase(); }).indexOf(cur) < 0 ? cur : '';
        html += '<input type="color" data-swc="' + target + '" value="' + (custom || (target === 'card' ? '#1e293b' : '#000000')) + '" aria-label="' + esc(L.swatch_custom || '') + '" title="' + esc(L.swatch_custom || '') + '">';
        if (host.__veHtml !== html) { host.innerHTML = html; host.__veHtml = html; }
        host.dataset.target = target;
    }
    function applySwatch(target, color, i, gestureKey) {
        var f = findSel(); if (!f || sel.kind !== 'clip') return;
        if (target === 'card') {
            if (i != null && CARD_PRESETS[i]) { f.item.color = CARD_PRESETS[i][0]; f.item.color2 = CARD_PRESETS[i][1]; }
            else { f.item.color = color; f.item.color2 = shade(color, -0.12); }
        } else f.item.bgColor = color;
        touch(); refresh(); commit(gestureKey);
    }
    ['ve-card-colors', 've-bg-colors'].forEach(function (id) {
        on($(id), 'click', function (ev) {
            var b = ev.target.closest('[data-sw]'); if (!b) return;
            applySwatch(this.dataset.target, b.getAttribute('data-sw'), this.dataset.target === 'card' ? +b.getAttribute('data-i') : null);
            ae(this.dataset.target === 'card' ? 'card_color' : 'clip_bg');
        });
        on($(id), 'input', function (ev) {
            if (!ev.target.matches || !ev.target.matches('[data-swc]')) return;
            applySwatch(this.dataset.target, ev.target.value, null, 'swc:' + this.dataset.target);
        });
    });

    /* Поле инспектора → свойство выбранного. `live` — перерисовать сразу,
       история — одной записью на жест (ключ по полю). `main` — правка
       сдвигает клипы: элементы поверх ленты едут за кадром. */
    function bindRange(id, kind, apply, label, main) {
        on($(id), 'input', function () {
            var f = findSel();
            if (!f || !sel || sel.kind !== kind) return;
            var v = parseFloat(this.value), key = id + ':' + sel.id;
            if (main) editMain(key, function () { apply(f.item, v); }); else apply(f.item, v);
            if (label) label(f.item, v);
            touch(); scheduleRefresh(); commit(key);
        });
    }

    bindRange('ve-speed', 'clip', function (it, v) { it.speed = clamp(v || 1, 0.25, 4); }, function (it) { $('ve-speed-v').textContent = nfmt(it.speed, 2) + '×'; }, true);
    bindRange('ve-volume', 'clip', function (it, v) { it.volume = clamp((v || 0) / 100, 0, 2); }, function (it) { $('ve-volume-v').textContent = pct(it.volume); });
    bindRange('ve-cfade-in', 'clip', function (it, v) { it.fadeIn = clamp(v || 0, 0, 10); }, function (it) { $('ve-cfade-in-v').textContent = secLabel(it.fadeIn); });
    bindRange('ve-cfade-out', 'clip', function (it, v) { it.fadeOut = clamp(v || 0, 0, 10); }, function (it) { $('ve-cfade-out-v').textContent = secLabel(it.fadeOut); });
    bindRange('ve-img-dur', 'clip', function (it, v) { var d = clamp(v || 4, 0.5, 600); it.duration = d; it.trimStart = 0; it.trimEnd = d; }, function (it) { $('ve-img-dur-v').textContent = secLabel(it.trimEnd); }, true);
    bindRange('ve-czoom', 'clip', function (it, v) { it.zoom = clamp((v || 100) / 100, 1, 4); }, function (it) { $('ve-czoom-v').textContent = pct(it.zoom); syncPanUi(it); });
    bindRange('ve-tx-dur', 'tx', function (it, v) { if (it.tx) it.tx.dur = clamp(v || 0.6, 0.1, 3); }, function (it) { if (it.tx) $('ve-tx-dur-v').textContent = secLabel(it.tx.dur); }, true);
    bindRange('ve-text-size', 'text', function (it, v) { TL.setValuesAt('text', it, playhead, { s: clamp(v || 6, 1, 40) }); }, function (it, v) { $('ve-text-size-v').textContent = nfmt(v, v % 1 ? 1 : 0) + '%'; });
    bindRange('ve-aud-vol', 'audio', function (it, v) { it.volume = clamp((v || 0) / 100, 0, 2); }, function (it) { $('ve-aud-vol-v').textContent = pct(it.volume); });
    bindRange('ve-afade-in', 'audio', function (it, v) { it.fadeIn = clamp(v || 0, 0, 30); }, function (it) { $('ve-afade-in-v').textContent = secLabel(it.fadeIn); });
    bindRange('ve-afade-out', 'audio', function (it, v) { it.fadeOut = clamp(v || 0, 0, 30); }, function (it) { $('ve-afade-out-v').textContent = secLabel(it.fadeOut); });
    bindRange('ve-redact-strength', 'region', function (it, v) { it.strength = clamp(Math.round(v || 6), 1, 10); }, function (it) { $('ve-redact-strength-v').textContent = String(it.strength); });
    bindRange('ve-ov-size', 'overlay', function (it, v) { TL.setValuesAt('overlay', it, playhead, { w: clamp((v || 25) / 100, 0.03, 1) }); }, function (it, v) { $('ve-ov-size-v').textContent = pct((v || 25) / 100); });
    bindRange('ve-ov-opacity', 'overlay', function (it, v) { TL.setValuesAt('overlay', it, playhead, { o: clamp((v || 100) / 100, 0.05, 1) }); }, function (it, v) { $('ve-ov-opacity-v').textContent = pct((v || 100) / 100); });
    bindRange('ve-ov-vol', 'overlay', function (it, v) { it.volume = clamp((v || 0) / 100, 0, 2); }, function (it) { $('ve-ov-vol-v').textContent = pct(it.volume); });
    bindRange('ve-ov-chroma-sim', 'overlay', function (it, v) { if (it.chroma) it.chroma.sim = clamp((v || 30) / 100, 0.02, 0.9); }, function (it, v) { $('ve-ov-chroma-sim-v').textContent = String(Math.round(v)); });
    bindRange('ve-ov-chroma-smooth', 'overlay', function (it, v) { if (it.chroma) it.chroma.smooth = clamp((v || 0) / 100, 0, 0.5); }, function (it, v) { $('ve-ov-chroma-smooth-v').textContent = String(Math.round(v)); });

    on($('ve-speed-chips'), 'click', function (ev) {
        var b = ev.target.closest('[data-speed]'); if (!b) return;
        var f = findSel(); if (!f || sel.kind !== 'clip' || f.item.kind !== 'video') return;
        var v = +b.getAttribute('data-speed');
        editMain(null, function () { f.item.speed = v; });
        touch(); refresh(); commit();
        ae('clip_speed_preset', { v: v });
    });

    function syncLook(it) {
        var b = it.bright == null ? 1 : it.bright, c = it.contrast == null ? 1 : it.contrast, s = it.sat == null ? 1 : it.sat;
        $('ve-bright').value = Math.round(b * 100); $('ve-bright-v').textContent = pct(b);
        $('ve-contrast').value = Math.round(c * 100); $('ve-contrast-v').textContent = pct(c);
        $('ve-sat').value = Math.round(s * 100); $('ve-sat-v').textContent = pct(s);
        var btns = $('ve-filters').querySelectorAll('[data-flt]');
        for (var i = 0; i < btns.length; i++) btns[i].classList.toggle('on', btns[i].getAttribute('data-flt') === (it.tone || 'none'));
    }
    bindRange('ve-bright', 'clip', function (it, v) { it.bright = clamp((v || 100) / 100, 0.3, 2); }, function (it) { syncLook(it); });
    bindRange('ve-contrast', 'clip', function (it, v) { it.contrast = clamp((v || 100) / 100, 0.3, 2); }, function (it) { syncLook(it); });
    bindRange('ve-sat', 'clip', function (it, v) { it.sat = clamp((v == null ? 100 : v) / 100, 0, 2); }, function (it) { syncLook(it); });
    on($('ve-look-reset'), 'click', function () {
        var f = findSel(); if (!f || sel.kind !== 'clip') return;
        f.item.bright = 1; f.item.contrast = 1; f.item.sat = 1; f.item.tone = 'none';
        touch(); refresh(); commit();
    });
    on($('ve-look-all'), 'click', function () {
        var f = findSel(); if (!f || sel.kind !== 'clip') return;
        var src = f.item, n = 0;
        project.clips.forEach(function (c) {
            if (c.kind === 'color' || c === src) return;
            c.tone = src.tone || 'none'; c.bright = src.bright; c.contrast = src.contrast; c.sat = src.sat; n++;
        });
        touch(); refresh(); commit();
        toast(String(L.applied_all || '').replace(':n', String(n)), 'success');
        ae('look_apply_all', { n: n });
    });
    on($('ve-frame-all'), 'click', function () {
        var f = findSel(); if (!f || sel.kind !== 'clip') return;
        var src = f.item, n = 0;
        project.clips.forEach(function (c) {
            if (c.kind === 'color' || c === src) return;
            c.fit = src.fit || 'contain'; c.bgColor = src.bgColor || '#000000'; n++;
        });
        touch(); refresh(); commit();
        toast(String(L.applied_all || '').replace(':n', String(n)), 'success');
        ae('frame_apply_all', { n: n, fit: src.fit });
    });

    /* Фильтры: образец — ТЕКУЩИЙ клип (миниатюра из середины его отрезка),
       под каждым фильтром своя канва. Строки фильтров — общие с рисовальщиком
       кадра (C.lookFilter), поэтому образец не врёт о том, что будет в файле. */
    var FILTER_KEYS = TL.FILTERS || ['none'];
    (function buildFilters() {
        $('ve-filters').innerHTML = FILTER_KEYS.map(function (k) {
            return '<button type="button" class="ve-flt" data-flt="' + k + '"><canvas width="96" height="54"></canvas><span>' + esc(L['filter_' + k] || k) + '</span></button>';
        }).join('');
    })();
    var fltRaf = 0;
    function scheduleFilterThumbs() { if (fltRaf) return; fltRaf = requestAnimationFrame(function () { fltRaf = 0; paintFilterThumbs(); }); }
    function paintFilterThumbs() {
        var f = findSel();
        if (!f || !sel || sel.kind !== 'clip' || $('ve-tab-look').hidden) return;
        var c = f.item, rec = media.get(c.mediaId), src = null;
        if (rec && rec.kind === 'image') src = rec.bitmap;
        else if (rec && rec.thumbs && rec.thumbs.length) {
            var mid = (c.trimStart + c.trimEnd) / 2, best = rec.thumbs[0];
            rec.thumbs.forEach(function (th) { if (Math.abs(th.t - mid) < Math.abs(best.t - mid)) best = th; });
            src = best.c;
        }
        var btns = $('ve-filters').querySelectorAll('[data-flt]');
        for (var i = 0; i < btns.length; i++) {
            var cv = btns[i].querySelector('canvas'), g = cv.getContext('2d');
            g.fillStyle = '#111'; g.fillRect(0, 0, cv.width, cv.height);
            if (!src) continue;
            var fs = C.lookFilter({ tone: btns[i].getAttribute('data-flt'), bright: 1, contrast: 1, sat: 1 });
            var sw = src.width, sh = src.height, k = Math.max(cv.width / sw, cv.height / sh);
            if (fs) g.filter = fs;
            try { g.drawImage(src, (cv.width - sw * k) / 2, (cv.height - sh * k) / 2, sw * k, sh * k); } catch (e) {}
            g.filter = 'none';
        }
        syncLook(c);
    }
    on($('ve-filters'), 'click', function (ev) {
        var b = ev.target.closest('[data-flt]'); if (!b) return;
        var f = findSel(); if (!f || sel.kind !== 'clip') return;
        f.item.tone = b.getAttribute('data-flt');
        touch(); refresh(); commit();
        ae('clip_filter', { v: f.item.tone });
    });

    function toggleFlip(axis) {
        var f = findSel(); if (!f || sel.kind !== 'clip') return;
        f.item[axis] = !f.item[axis];
        touch(); refresh(); commit();
        ae('clip_flip', { a: axis });
    }
    on($('ve-flip-h'), 'click', function () { toggleFlip('flipH'); });
    on($('ve-flip-v'), 'click', function () { toggleFlip('flipV'); });

    on($('ve-mute'), 'change', function () { var f = findSel(); if (!f || sel.kind !== 'clip') return; f.item.mute = this.checked; touch(); refresh(); commit(); });
    on($('ve-aud-mute'), 'change', function () { var f = findSel(); if (!f || sel.kind !== 'audio') return; f.item.mute = this.checked; touch(); refresh(); commit(); ae('audio_mute', { on: this.checked ? 1 : 0 }); });
    on($('ve-aud-duck'), 'change', function () { var f = findSel(); if (!f || sel.kind !== 'audio') return; f.item.duck = this.checked; touch(); refresh(); commit(); ae('audio_duck', { on: this.checked ? 1 : 0 }); });
    on($('ve-aud-loop'), 'change', function () { var f = findSel(); if (!f || sel.kind !== 'audio') return; f.item.loop = this.checked; touch(); refresh(); commit(); ae('audio_loop', { on: this.checked ? 1 : 0 }); });
    on($('ve-text-content'), 'input', function () { var f = findSel(); if (!f || sel.kind !== 'text') return; f.item.text = this.value; touch(); scheduleRefresh(); commit('text:' + sel.id); });
    on($('ve-text-color'), 'input', function () { var f = findSel(); if (!f || sel.kind !== 'text') return; f.item.color = this.value; touch(); scheduleRefresh(); commit('color:' + sel.id); renderStyles(f.item); });
    on($('ve-text-bgcolor'), 'input', function () { var f = findSel(); if (!f || sel.kind !== 'text') return; f.item.bgColor = this.value; touch(); scheduleRefresh(); commit('bgcolor:' + sel.id); renderStyles(f.item); });
    on($('ve-text-font'), 'change', function () {
        var f = findSel(); if (!f || sel.kind !== 'text') return;
        f.item.font = this.value; touch(); refresh(); commit();
        ae('text_font', { v: this.value });
    });
    on($('ve-text-anim'), 'change', function () {
        var f = findSel(); if (!f || sel.kind !== 'text') return;
        f.item.anim = this.value; touch(); refresh(); commit();
        // Показать появление: с начала титра две секунды и стоп — без этого
        // выбор из списка ничего не меняет на стоящем кадре.
        if (preview.isPlaying()) { preview.pause(); setPlayBtn(false); }
        playhead = f.item.start; updatePlayhead();
        if (this.value !== 'none') { togglePlay(); demoStop = Math.min(f.item.end, f.item.start + 2); }
        else preview.render(playhead);
        ae('text_anim', { v: this.value });
    });
    // Гарнитура догрузилась — перерисовать кадр, иначе титр так и стоит запасным шрифтом.
    if (OV && OV.onFontReady) OV.onFontReady(function () { if (!preview.isPlaying()) preview.render(playhead); });

    /* Стили титров: образец «Аа» рисуется CSS тем же шрифтом и цветом. */
    function styleMatch(it, s) {
        return (it.font || 'sans') === s.font && String(it.color || '').toLowerCase() === s.color && (it.bg || 'shadow') === s.bg
            && String(it.bgColor || '#000000').toLowerCase() === s.bgColor;
    }
    function renderStyles(it) {
        var host = $('ve-text-styles');
        if (!host.__built) {
            host.innerHTML = STYLES.map(function (s) {
                var css = 'font-family:' + STYLE_CSS_FONT[s.font] + ',sans-serif;color:' + s.color + ';';
                if (s.bg === 'box') css += 'background:' + s.bgColor + ';';
                if (s.bg === 'shadow') css += '-webkit-text-stroke:1px ' + s.bgColor + ';paint-order:stroke fill;';
                if (s.bg === 'glow') css += 'text-shadow:0 0 6px ' + s.bgColor + ',0 0 10px ' + s.bgColor + ';';
                var nm = L['style_' + s.key] || s.key;
                return '<button type="button" class="ve-sty" data-sty="' + s.key + '" title="' + esc(nm) + '" aria-label="' + esc(nm) + '"><span class="s" style="' + css + '">Аа</span></button>';
            }).join('');
            host.__built = true;
        }
        var bs = host.querySelectorAll('[data-sty]');
        for (var i = 0; i < bs.length; i++) bs[i].classList.toggle('on', styleMatch(it, STYLES[i]));
    }
    on($('ve-text-styles'), 'click', function (ev) {
        var b = ev.target.closest('[data-sty]'); if (!b) return;
        var f = findSel(); if (!f || sel.kind !== 'text') return;
        var s = STYLES.filter(function (x) { return x.key === b.getAttribute('data-sty'); })[0];
        if (!s) return;
        ['font', 'color', 'bg', 'bgColor', 'sizePct'].forEach(function (k) { f.item[k] = s[k]; });
        if (s.y != null) f.item.y = s.y;
        if (s.anim) f.item.anim = s.anim;
        touch(); refresh(); commit();
        ae('text_style', { v: s.key });
    });
    /* Положение титра: сверху, посередине или снизу — по высоте его блока. */
    function placeText(it, where) {
        var ctx2 = canvas.getContext('2d'), W = canvas.width, H = canvas.height;
        var hFrac = OV ? OV.measure(ctx2, keyedText(it, playhead), W, H).h / H : 0.1;
        var ny = where === 'top' ? 0.07 : where === 'middle' ? clamp(0.5 - hFrac / 2, 0, 1) : clamp(0.93 - hFrac, 0, 1);
        TL.setValuesAt('text', it, playhead, { x: 0.5, y: ny });
        it.align = 'center';
    }
    /* Круг — квадрат со стороной ширины: наложение, стоявшее у нижнего края
       прямоугольником, после смены формы вылезало бы за кадр. Без движения по
       ключам центр подвигается так, чтобы рамка осталась в кадре. */
    function fitOverlayInFrame(it) {
        if (it.keys && it.keys.length) return;
        var W = canvas.width, H = canvas.height, b = C.overlayBox(TL._normOverlay(it, 0), W, H);
        var hw = b.w / W / 2, hh = b.h / H / 2;
        it.x = clamp(it.x, Math.min(0.5, hw), Math.max(0.5, 1 - hw));
        it.y = clamp(it.y, Math.min(0.5, hh), Math.max(0.5, 1 - hh));
    }
    /* Наложение в угол: поля 4 % кадра. */
    function placeOverlay(it, where) {
        var W = canvas.width, H = canvas.height, b = C.overlayBox(keyedOverlay(it, playhead), W, H);
        var hw = b.w / W / 2, hh = b.h / H / 2, m = 0.04;
        if (where === 'c') { TL.setValuesAt('overlay', it, playhead, { x: 0.5, y: 0.5 }); return; }
        TL.setValuesAt('overlay', it, playhead, { x: where === 'tl' || where === 'bl' ? m + hw : 1 - m - hw,
            y: where === 'tl' || where === 'tr' ? m + hh : 1 - m - hh });
    }

    // Сегменты и кнопки действий в инспекторе — одним делегатом.
    on($('ve-insp'), 'click', function (ev) {
        var f = findSel();
        var segB = ev.target.closest('.tc-seg-b[data-v]');
        if (segB && f && segB.parentNode.getAttribute('data-seg')) {
            var name = segB.parentNode.getAttribute('data-seg'), v = segB.getAttribute('data-v');
            if (name === 'fit') f.item.fit = v;
            else if (name === 'rotation') f.item.rotation = parseInt(v, 10) || 0;
            else if (name === 'align') f.item.align = v;
            else if (name === 'bg') f.item.bg = v;
            else if (name === 'rmode') f.item.mode = v === 'blur' ? 'blur' : 'pixelate';
            else if (name === 'motion') f.item.motion = (v === 'in' || v === 'out') ? v : 'none';
            else if (name === 'tpos') placeText(f.item, v);
            else if (name === 'ovpos') placeOverlay(f.item, v);
            else if (name === 'ovanim') f.item.anim = v;
            else if (name === 'ovshape') { f.item.shape = v; fitOverlayInFrame(f.item); ae('overlay_shape', { v: v }); }
            else if (name === 'ovborder') f.item.border = v;
            else if (name === 'ease') f.item.ease = v === 'linear' ? 'linear' : 'smooth';
            else if (name === 'chroma') { setChromaColor(f.item, v); }
            touch(); refresh(); commit();
            if (name === 'fit') ae('clip_fit', { v: v });
            if (name === 'motion') ae('photo_motion', { v: v });
            if (name === 'tpos' || name === 'ovpos') ae(name, { v: v });
            return;
        }
        var chip = ev.target.closest('[data-tx]');
        if (chip && f && sel.kind === 'tx') {
            var type = chip.getAttribute('data-tx');
            editMain(null, function () { f.item.tx = type === 'none' ? null : { type: type, dur: (f.item.tx && f.item.tx.dur) || 0.6 }; });
            touch(); refresh(); commit();
            showTransitionPoint();
            ae('transition', { type: type });
            return;
        }
        var act = ev.target.closest('[data-act]');
        if (act) doAct(act.getAttribute('data-act'));
    });
    /* Переход виден, только если ползунок на нём: выбор перехода ставит
       ползунок в его середину и проигрывает его. */
    function showTransitionPoint() {
        var f = findSel(); if (!f || !sel || sel.kind !== 'tx') return;
        var t = tl();
        if (f.item.tx && t.overlaps[f.index] > 0) {
            var mid = t.starts[f.index + 1] + t.overlaps[f.index] / 2;
            seekTo(mid);
        } else if (f.index < t.clips.length - 1) seekTo(t.starts[f.index + 1]);
    }
    on($('ve-tx-all'), 'click', function () {
        var f = findSel();
        if (!f || !f.item.tx) return;
        var tx = f.item.tx;
        editMain(null, function () { project.clips.forEach(function (c, i) { if (i < project.clips.length - 1) c.tx = { type: tx.type, dur: tx.dur }; }); });
        touch(); refresh(); commit();
        ae('transition_all', { type: tx.type });
    });

    function doAct(a) {
        if (a === 'split') return splitNow();
        if (a === 'del') return deleteSel();
        if (a === 'dup') return duplicateSel();
        if (a === 'freeze') return freezeFrame();
        if (a === 'detach') return detachAudio();
        if (a === 'pip') return makeOverlayFromClip();
    }

    function splitNow() {
        if (sel && sel.kind === 'audio') return splitAudio();
        var r = TL.splitAt(project.clips, playhead, nid('c'));
        if (r.splitAt < 0) { toast(r.reason === 'transition' ? L.split_transition : L.split_nothing, 'info'); return; }
        project.clips = r.clips;
        sel = { kind: 'clip', id: project.clips[r.splitAt + 1].id };
        touch(); refresh(); commit();
        try { window.__aeFunnel && window.__aeFunnel('clip_split', { n: project.clips.length }); } catch (e) {}
    }
    function splitAudio() {
        var f = findSel();
        if (!f) return;
        var a = f.item, t = tl(), sp = t.itemSpan(f.index);
        if (a.loop || playhead <= sp.start + 0.1 || playhead >= sp.end - 0.1) { toast(L.split_nothing, 'info'); return; }
        var cut = a.trimStart + (playhead - a.start);
        var right = copy(a);
        right.id = nid('a'); right.start = playhead; right.trimStart = cut; right.fadeIn = 0;
        a.trimEnd = cut; a.fadeOut = 0;
        project.audio.splice(f.index + 1, 0, right);
        sel = { kind: 'audio', id: right.id };
        touch(); refresh(); commit();
    }
    function deleteSel() {
        var f = findSel();
        if (!f) { toast(L.nothing_to_delete, 'info'); return; }
        var kind = sel.kind;
        if (kind === 'tx') { editMain(null, function () { f.item.tx = null; }); }
        else if (kind === 'clip') { editMain(null, function () { project.clips.splice(f.index, 1); tidyTransitions(); }); delete thumbCache[f.item.id]; }
        else listOf(kind).splice(f.index, 1);
        var list = listOf(kind);
        sel = (kind !== 'tx' && list.length) ? { kind: kind, id: list[Math.min(f.index, list.length - 1)].id } : null;
        touch(); refresh(); commit();
        if (!hasWork()) { preview.pause(); setPlayBtn(false); }
    }
    function duplicateSel() {
        var f = findSel();
        if (!f || sel.kind === 'tx') return;
        var c = copy(f.item), kind = sel.kind;
        if (kind === 'clip') {
            c.id = nid('c');
            editMain(null, function () { project.clips.splice(f.index + 1, 0, c); });
        } else if (kind === 'audio') {
            var t = tl(), sp = t.itemSpan(f.index);
            c.id = nid('a'); c.start = sp.end; c.voice = !!c.voice;
            project.audio.push(c);
        } else {
            // Титр, наложение, скрытие: копия встаёт сразу за оригиналом.
            var len = c.end - c.start;
            c.id = nid(kind === 'text' ? 't' : kind === 'overlay' ? 'o' : 'r');
            c.start = f.item.end; c.end = c.start + len;
            if (c.keys) c.keys.forEach(function (k) { k.t += len; });
            listOf(kind).push(c);
        }
        sel = { kind: kind, id: c.id };
        touch(); refresh(); commit();
        ae('duplicate', { k: kind });
    }

    /* Стоп-кадр: кадр под ползунком — фото на 2 с между половинками клипа.
       Кадр снимается из исходника в его размере (не с превью 960 px), и
       фото получает те же вписывание, поворот, отражение и цвет, что клип. */
    async function freezeFrame() {
        var f = findSel();
        if (!f || sel.kind !== 'clip' || f.item.kind !== 'video' || busy) return;
        var t = tl(), fr = t.frameAt(playhead);
        if (!fr || fr.a.index !== f.index) { bringIntoView('clip', f.item.id); fr = tl().frameAt(playhead); }
        if (!fr || fr.a.clip.id !== f.item.id) return;
        var rec = media.get(f.item.mediaId);
        if (!rec || rec.state !== 'ready') return;
        var file = null;
        try { file = await media.grabFrame(rec, fr.a.sourceSec, String(f.item.name || 'clip').replace(/\.[^.]+$/, '') + '-' + fmt(fr.a.sourceSec).replace(/[:.]/g, '-') + '.jpg'); } catch (e) { file = null; }
        if (!file) { toast(L.freeze_failed, 'error'); return; }
        var r = media.add(file);
        await r.ready;
        if (r.state !== 'ready') { media.remove(r.id); toast(L.freeze_failed, 'error'); return; }
        var base = f.item;
        var still = { id: nid('c'), kind: 'image', mediaId: r.id, name: r.name, duration: 2, trimStart: 0, trimEnd: 2, speed: 1,
            volume: 1, mute: false, fadeIn: 0, fadeOut: 0, rotation: base.rotation || 0, flipH: !!base.flipH, flipV: !!base.flipV,
            fit: base.fit, bgColor: base.bgColor, zoom: base.zoom, panX: base.panX, panY: base.panY, tone: base.tone,
            bright: base.bright, contrast: base.contrast, sat: base.sat, tx: null, width: r.width, height: r.height, hasAudio: false };
        var at = playhead;
        editMain(null, function () {
            var sp = TL.splitAt(project.clips, at, nid('c'));
            if (sp.splitAt >= 0) { project.clips = sp.clips; project.clips.splice(sp.splitAt + 1, 0, still); }
            else {
                // На самом краю клипа — стоп-кадр встаёт до него или после.
                var idx = f.index + ((fr.a.localSec > tl().effDur[f.index] / 2) ? 1 : 0);
                project.clips.splice(idx, 0, still);
            }
        });
        sel = { kind: 'clip', id: still.id };
        touch(); refresh(); commit();
        toast(L.freeze_done, 'success');
        ae('freeze_frame');
    }

    /* Отделить звук: звук клипа — отдельной дорожкой с той же обрезкой, клип
       без звука. Дальше звук двигают, режут и приглушают сами по себе
       (подводка звука следующей сцены, «звук остаётся, картинка сменилась»). */
    function detachAudio() {
        var f = findSel();
        if (!f || sel.kind !== 'clip' || f.item.kind !== 'video') return;
        var c = f.item;
        if (c.hasAudio === false) { toast(L.detach_none, 'info'); return; }
        if (Math.abs((c.speed || 1) - 1) > 1e-3) { toast(L.detach_speed, 'info'); return; }
        var rec = media.get(c.mediaId);
        // Звук дорожки собирается целиком в память; у многочасового ролика это
        // гигабайты — такие клипы отделять не даём.
        if (rec && rec.duration > 20 * 60) { toast(L.detach_long, 'info'); return; }
        var sp = tl().spanOf(f.index);
        var item = { id: nid('a'), mediaId: c.mediaId, name: (c.name || '').replace(/\.[^.]+$/, ''), duration: c.duration,
            start: sp.start, trimStart: c.trimStart, trimEnd: c.trimEnd, volume: c.volume, fadeIn: c.fadeIn || 0, fadeOut: c.fadeOut || 0,
            loop: false, detached: c.id };
        project.audio.push(item);
        c.mute = true;
        sel = { kind: 'audio', id: item.id };
        touch(); refresh(); commit();
        toast(L.detach_done, 'success');
        ae('detach_audio');
    }

    /* ── кнопки панели ──────────────────────────────────────────────────── */
    function openPicker() { if (upload.__uploaderOpen) upload.__uploaderOpen(); }
    on($('ve-add-media'), 'click', function () { overlayPick = 0; openPicker(); });
    on($('ve-add-audio'), 'click', function () { overlayPick = 0; openPicker(); });
    on($('ve-add-subs'), 'click', function () { overlayPick = 0; openPicker(); ae('subs_open'); });
    on($('ve-add-overlay'), 'click', function () {
        if (busy) return;
        if (!project.clips.length) { toast(L.overlay_needs_image, 'info'); }
        overlayPick = Date.now(); openPicker(); ae('overlay_open');
    });
    on($('ve-add-text'), 'click', function () { addText(); });
    on($('ve-add-card'), 'click', addCard);

    /* ── запись голоса ─────────────────────────────────────────────────────
       Микрофон, часы и сдвиг — у voice.js (общие MicManager, RecordingLatency,
       TakeLevel); здесь только лента: откуда играть, куда положить дубль. */
    var VO = window.VideoEditorVoice ? window.VideoEditorVoice.create({
        L: L, ae: ae, toast: toast,
        ctx: function () { return preview.audioCtx(); },
        from: function () { return playhead >= tl().duration - 0.3 ? 0 : playhead; },
        play: function (from) {
            preview.setModel(tl(), project.regions);
            preview.play(from);
            // Кнопка под превью во время дубля — «Стоп»: на телефоне панель
            // записи ниже ленты, а смотрит человек на видео.
            playBtn.classList.add('is-rec');
            setPlayBtn(true);
        },
        stop: function () { preview.pause(); setPlayBtn(false); preview.render(playhead); },
        onBegin: function () {
            busy = true; root.classList.add('is-recording');
            try { $('ve-stage').scrollIntoView({ block: 'nearest' }); } catch (e) {}
        },
        onEnd: function () { busy = false; root.classList.remove('is-recording'); playBtn.classList.remove('is-rec'); setPlayBtn(false); },
        onClose: function () {
            if (sel && sel.kind === 'voice') { sel = null; syncInspector(); renderTimeline(); }
        },
        onTake: function (file, start, meta) { addVoiceTake(file, start, meta); },
        ui: { pane: $('ve-insp-voice'), go: $('ve-voice-go'), status: $('ve-voice-status'), vu: $('ve-voice-vu-i'), row: $('recSyncRow') },
    }) : null;

    function openVoice() {
        if (busy || !VO) return;
        if (!project.clips.length) { toast(L.voice_needs_clip, 'info'); return; }
        if (VO.isActive()) return;
        preview.pause(); setPlayBtn(false);
        sel = { kind: 'voice', id: 'voice' };
        syncInspector(); renderTimeline(); preview.render(playhead);
        try { $('ve-insp-voice').scrollIntoView({ block: 'nearest' }); } catch (e) {}
        VO.open();
        ae('voice_open');
    }
    async function addVoiceTake(file, start, meta) {
        var r = media.add(file);
        pending[r.id] = r;
        renderPending();
        await r.ready;
        delete pending[r.id];
        renderPending();
        if (r.state !== 'ready') { toast(L.voice_failed, 'error'); media.remove(r.id); return; }
        var d = r.duration > 0 ? r.duration : meta.duration;
        var item = { id: nid('a'), mediaId: r.id, name: meta.name, duration: d, start: start, trimStart: 0, trimEnd: d,
            volume: 1, fadeIn: 0, fadeOut: 0, loop: false, voice: true };
        project.audio.push(item);
        sel = { kind: 'audio', id: item.id };
        touch(); refresh(); commit();
        toast(L.voice_added, 'success');
    }
    on($('ve-add-voice'), 'click', openVoice);
    on($('ve-voice-go'), 'click', function () {
        if (!VO) return;
        if (VO.isRecording()) VO.finish(); else if (VO.phase() === 'ready') VO.begin();
    });
    on($('ve-voice-close'), 'click', function () { if (VO) VO.close(); });
    on($('ve-redact-add'), 'click', addRegion);
    on($('ve-undo'), 'click', undo);
    on($('ve-redo'), 'click', redo);
    on($('ve-split'), 'click', splitNow);
    on($('ve-del'), 'click', deleteSel);
    function addFromTrack(kind) {
        if (kind === 'text') addText();
        else if (kind === 'redact') addRegion();
        else if (kind === 'overlay') { overlayPick = Date.now(); openPicker(); }
        else openPicker();
    }

    function addText(opts) {
        opts = opts || {};
        var d = tl().duration || 5;
        var start = opts.start != null ? opts.start : Math.min(playhead, Math.max(0, d - 1));
        // Титр не длиннее ролика: у самого конца он укорачивается, а не
        // уходит за конец видео (где его никто не увидит).
        var end = opts.end != null ? opts.end : Math.min(start + 3, Math.max(start + 1, d));
        var x = { id: nid('t'), text: opts.text || L.text_placeholder || 'Текст', start: start, end: end,
            x: 0.5, y: 0.78, sizePct: 6, color: '#ffffff', bg: 'shadow', bgColor: '#000000', align: 'center', fadeSec: 0.25, font: 'sans', anim: 'fade' };
        if (opts.style) {
            var s = STYLES.filter(function (q) { return q.key === opts.style; })[0];
            if (s) { ['font', 'color', 'bg', 'bgColor', 'sizePct'].forEach(function (k) { x[k] = s[k]; }); if (s.y != null) x.y = s.y; if (s.anim) x.anim = s.anim; }
        }
        project.texts.push(x);
        if (opts.silent) return x;
        sel = { kind: 'text', id: x.id };
        // ⚠️ Ползунок — ВНУТРЬ титра: на его первом кадре прозрачность нулевая,
        // и человек нажимает «Добавить титр», не видя ничего.
        playhead = Math.min(end - 0.01, start + Math.max(0.4, (end - start) / 2));
        touch(); refresh(); commit();
        var ta = $('ve-text-content');
        if (ta) { try { ta.focus({ preventScroll: true }); ta.select(); } catch (e) {} }
        try { window.__aeFunnel && window.__aeFunnel('text_added', { n: project.texts.length }); } catch (e) {}
        return x;
    }

    /* Заставка: цветной кадр на 3 с с заголовком — у ползунка (до клипа под
       ним, если ползунок в его первой половине, иначе после). */
    function addCard() {
        if (busy) return;
        var t = tl(), idx = 0;
        if (t.clips.length) {
            var fr = t.frameAt(playhead);
            if (!fr) idx = playhead <= 0.01 ? 0 : t.clips.length;
            else idx = fr.a.index + (fr.a.localSec > t.effDur[fr.a.index] / 2 ? 1 : 0);
        }
        var card = { id: nid('c'), kind: 'color', mediaId: null, name: '', duration: 3, trimStart: 0, trimEnd: 3, speed: 1,
            volume: 1, mute: false, fadeIn: 0, fadeOut: 0, rotation: 0, fit: 'contain', tx: null, hasAudio: false,
            color: CARD_PRESETS[0][0], color2: CARD_PRESETS[0][1] };
        editMain(null, function () { project.clips.splice(idx, 0, card); });
        touch();
        var start = tl().starts[idx] || 0;
        showWorkspace();
        var x = addText({ start: start, end: start + 3, text: L.card_text_default, style: 'title', silent: true });
        x.y = 0.42;
        sel = { kind: 'clip', id: card.id };
        playhead = start + 1.5;
        touch(); fitAspectCanvas(); if (!userZoomed) zoomFit(); refresh(); commit();
        toast(L.card_added, 'success');
        ae('card_added');
    }
    on($('ve-card-text'), 'click', function () {
        var f = findSel(); if (!f || sel.kind !== 'clip') return;
        var sp = tl().spanOf(f.index);
        addText({ start: sp.start, end: sp.end, text: L.card_text_default, style: 'title' });
    });

    /* Скрытие: область встаёт НА ТЕКУЩЕМ месте ползунка и длиной три секунды:
       у записи регистратора чужой номер держится в кадре примерно столько. */
    function addRegion() {
        var t = tl();
        if (!t.clips.length) { toast(L.need_clip, 'error'); return; }
        var start = clamp(playhead, 0, Math.max(0, t.duration - 0.2));
        var end = Math.min(t.duration, start + 3);
        var g = { id: nid('r'), mode: 'pixelate', strength: 6, start: start, end: end,
            keys: [{ t: start, x: 0.38, y: 0.55, w: 0.24, h: 0.12 }] };
        project.regions.push(g);
        sel = { kind: 'region', id: g.id };
        touch(); refresh(); commit();
        try { window.__aeFunnel && window.__aeFunnel('redact_added', { n: project.regions.length }); } catch (e) {}
    }
    /* Ключевая точка ставится там, где стоит ползунок, и запоминает ТЕКУЩЕЕ
       положение области: путь задаётся теми кадрами, на которые человек
       посмотрел, — без слежения и без сюрпризов между ними. */
    on($('ve-redact-key'), 'click', function () {
        var f = findSel();
        if (!f || sel.kind !== 'region') return;
        var g = f.item, r = RD.rectAt(g, playhead);
        if (!r) {
            g.start = Math.min(g.start, playhead); g.end = Math.max(g.end, playhead);
            r = RD.rectAt(g, playhead) || { x: 0.38, y: 0.55, w: 0.24, h: 0.12 };
        }
        var same = null;
        for (var i = 0; i < g.keys.length; i++) if (Math.abs(g.keys[i].t - playhead) < 0.03) same = g.keys[i];
        if (same) { same.x = r.x; same.y = r.y; same.w = r.w; same.h = r.h; }
        else g.keys.push({ t: playhead, x: r.x, y: r.y, w: r.w, h: r.h });
        touch(); refresh(); commit();
        ae('redact_key', { keys: g.keys.length });
    });
    /* ── ключевые кадры титра и наложения ────────────────────────────────
       Ключ ставится в кадре ползунка с тем, что сейчас видно; дальше правка
       в другом кадре (мышью, ползунком, кнопками положения) ставит там второй
       ключ — между ними элемент движется сам. Листать — от ключа к ключу. */
    on($('ve-insp'), 'click', function (ev) {
        var b = ev.target.closest('[data-key-act]');
        if (!b || b.disabled) return;
        var f = findSel();
        if (!f || (sel.kind !== 'text' && sel.kind !== 'overlay')) return;
        var kind = sel.kind, it = f.item, a = b.getAttribute('data-key-act');
        if (a === 'toggle') {
            // Ключ вне окна элемента не виден — ползунок сперва входит в окно.
            if (playhead < it.start || playhead > it.end) seekTo(clamp(playhead, it.start, it.end));
            var onK = TL.toggleKeyAt(kind, it, playhead);
            touch(); refresh(); commit();
            ae('key_toggle', { k: kind, on: onK ? 1 : 0, n: (it.keys || []).length });
            return;
        }
        var ks = (it.keys || []).map(function (k) { return k.t; }).sort(function (x, y) { return x - y; }), to = null;
        if (a === 'prev') ks.forEach(function (t) { if (t < playhead - TL.KEY_SNAP) to = t; });
        else for (var i = 0; i < ks.length; i++) if (ks[i] > playhead + TL.KEY_SNAP) { to = ks[i]; break; }
        if (to != null) { seekTo(to); syncInspector(); }
    });

    /* ── видео поверх видео: звук ─────────────────────────────────────── */
    on($('ve-ov-mute'), 'change', function () {
        var f = findSel(); if (!f || sel.kind !== 'overlay') return;
        f.item.mute = !!this.checked;
        touch(); refresh(); commit();
    });

    /* ── хромакей ─────────────────────────────────────────────────────────
       «Авто» берёт цвет фона с краёв кадра: у съёмки на зелёном или синем
       экране по краям — фон, а человек в середине. Медиана по каждому каналу,
       а не среднее: рука или микрофон у края не сдвигают цвет. */
    function sourceFrameOf(it) {
        var r = media.get(it.mediaId);
        if (!r) return null;
        if (r.bitmap) return r.bitmap;
        var th = r.thumbs && r.thumbs.length ? r.thumbs[Math.min(1, r.thumbs.length - 1)] : null;
        if (th && th.c) return th.c;
        return (r.el && r.el.readyState >= 2) ? r.el : null;
    }
    function detectKeyColor(img) {
        try {
            var S = 64, c = document.createElement('canvas'); c.width = S; c.height = S;
            var g = c.getContext('2d', { willReadFrequently: true });
            g.drawImage(img, 0, 0, S, S);
            var d = g.getImageData(0, 0, S, S).data, R = [], G = [], B = [], band = 6;
            for (var y = 0; y < S; y++) for (var x = 0; x < S; x++) {
                if (x >= band && x < S - band && y >= band && y < S - band) continue;
                var i = (y * S + x) * 4; R.push(d[i]); G.push(d[i + 1]); B.push(d[i + 2]);
            }
            function med(a) { a.sort(function (p, q) { return p - q; }); return a[a.length >> 1]; }
            var r = med(R), gg = med(G), b = med(B);
            // Серый край (обычная съёмка) — не однотонный цветной фон.
            if (Math.max(r, gg, b) - Math.min(r, gg, b) < 50) return null;
            return '#' + [r, gg, b].map(function (v) { return ('0' + v.toString(16)).slice(-2); }).join('');
        } catch (e) { return null; }
    }
    function setChromaColor(it, v) {
        if (!it.chroma) it.chroma = { color: '#00ff00', sim: 0.3, smooth: 0.08, spill: 0.1 };
        if (v === 'auto') {
            var src = sourceFrameOf(it), col = src ? detectKeyColor(src) : null;
            if (!col) { toast(L.chroma_auto_none, 'info'); col = '#00ff00'; }
            it.chroma.color = col;
            ae('chroma', { v: 'auto', ok: col !== '#00ff00' ? 1 : 0 });
        } else if (/^#[0-9a-f]{6}$/i.test(v)) { it.chroma.color = v.toLowerCase(); ae('chroma', { v: v }); }
    }
    on($('ve-ov-chroma'), 'change', function () {
        var f = findSel(); if (!f || sel.kind !== 'overlay') return;
        if (this.checked) setChromaColor(f.item, 'auto'); else f.item.chroma = null;
        touch(); refresh(); commit();
    });
    on($('ve-ov-chroma-color'), 'input', function () {
        var f = findSel(); if (!f || sel.kind !== 'overlay' || !f.item.chroma) return;
        setChromaColor(f.item, this.value);
        touch(); scheduleRefresh(); commit('chroma:' + sel.id);
    });

    /* ── «Поверх видео»: клип уходит с ленты на дорожку наложений ─────────
       Два ролика брошены подряд, а нужен «ведущий в кружке» поверх первого:
       клип снимается с ленты (всё после него съезжает) и ложится наложением
       туда же, где шёл, — но не дальше конца ролика. */
    function makeOverlayFromClip() {
        var f = findSel();
        if (!f || sel.kind !== 'clip' || f.item.kind === 'color' || project.clips.length < 2 || busy) return;
        var c = f.item, rec = media.get(c.mediaId);
        if (!rec || rec.state !== 'ready') return;
        var sp = tl().spanOf(f.index), len = Math.max(0.2, sp.end - sp.start);
        editMain(null, function () { project.clips.splice(f.index, 1); tidyTransitions(); });
        delete thumbCache[c.id];
        var total = tl().duration;
        var start = clamp(sp.start, 0, Math.max(0, total - Math.min(len, total)));
        var o;
        if (c.kind === 'video') {
            var te = Math.min(c.trimEnd, c.trimStart + Math.max(0.2, total - start));
            o = addOverlayItem(rec, { start: start, trimStart: c.trimStart, trimEnd: te, volume: c.volume, mute: c.mute, silent: true });
        } else {
            o = addOverlayItem(rec, { start: start, silent: true });
            o.end = start + Math.max(0.5, Math.min(len, total - start));
        }
        touch(); refresh(); commit();
        toast(L.make_overlay_done, 'success');
        ae('make_overlay', { k: c.kind });
    }

    /* ── обратный ход ──────────────────────────────────────────────────────
       Перевёрнутая копия ОТРЕЗКА клипа — движком /reverse-video (кадры
       аппаратным декодером в обратном порядке, звук тоже задом наперёд), и
       клип переезжает на неё: превью и файл дальше играют её как обычное
       видео. «Обычный ход» возвращает исходник без кодирования (TL.forwardClip). */
    var reversing = null;
    function showRevProg(p) {
        $('ve-rev-prog').hidden = false;
        $('ve-rev-bar').style.width = Math.round(Math.max(0, Math.min(1, p)) * 100) + '%';
        $('ve-rev-text').textContent = String(L.reverse_working || '').replace(':pct', Math.round(Math.max(0, Math.min(1, p)) * 100) + '%');
    }
    function indexOfClip(id) {
        for (var i = 0; i < project.clips.length; i++) if (project.clips[i].id === id) return i;
        return -1;
    }
    async function reverseClip() {
        var f = findSel();
        if (!f || sel.kind !== 'clip' || f.item.kind !== 'video' || reversing || busy) return;
        var c = f.item;
        if (c.reverseOf) {
            var fwd = TL.forwardClip(c), back = media.get(fwd.mediaId);
            if (!back) { toast(L.reverse_failed, 'error'); return; }
            project.clips[f.index] = fwd;
            delete thumbCache[c.id];
            touch(); refresh(); commit();
            ae('reverse', { on: 0 });
            return;
        }
        var RW = window.ReverseWebCodecs, VM = window.VideoMergeWebCodecs;
        var rec = media.get(c.mediaId);
        if (!RW || !VM || !rec || rec.state !== 'ready') { toast(L.reverse_failed, 'error'); return; }
        var snap = { id: c.id, mediaId: c.mediaId, ts: c.trimStart, te: c.trimEnd };
        var ctl = new AbortController();
        reversing = { id: c.id, ctl: ctl };
        showRevProg(0);
        syncInspector();
        var t0 = Date.now();
        try {
            // Движок разворота читает mp4-семейство; остальное сперва приводится
            // к H.264 той же дверью, что и для сборки (копия живёт у записи).
            var file = rec.lifted || rec.file;
            if (!VM.isMp4Family(file)) {
                file = await liftForEngine(file, chooseTarget(tl()), ctl.signal);
                if (ctl.signal.aborted) throw new DOMException('Aborted', 'AbortError');
                if (!file) throw new Error('lift');
                rec.lifted = file;
            }
            var blob = await RW.reverse(file, { mode: 'reverse', audio: c.hasAudio === false ? 'mute' : 'reverse', speed: 1,
                format: 'mp4', crf: 18, trim: { start: snap.ts, end: snap.te } },
                { signal: ctl.signal, onProgress: function (p) { showRevProg(p); } });
            var nm = String(c.name || 'clip').replace(/\.[^.]+$/, '') + '-reverse.mp4';
            var r = media.add(new File([blob], nm, { type: 'video/mp4' }));
            await r.ready;
            if (r.state !== 'ready') { media.remove(r.id); throw new Error('probe:' + (r.error || '')); }
            // Копия — тот же файл для суточного лимита: ключ исходника.
            r.limitKey = limitKeyOf(rec);
            var i = indexOfClip(snap.id), cur = i >= 0 ? project.clips[i] : null;
            if (!cur || cur.mediaId !== snap.mediaId || Math.abs(cur.trimStart - snap.ts) > 1e-3 || Math.abs(cur.trimEnd - snap.te) > 1e-3) {
                toast(L.reverse_changed, 'info');
                return;
            }
            project.clips[i] = TL.reversedClip(cur, { mediaId: r.id, duration: r.duration });
            delete thumbCache[cur.id];
            touch(); refresh(); commit();
            toast(L.reverse_done, 'success');
            ae('reverse', { on: 1, sec: Math.round(snap.te - snap.ts), ms: Date.now() - t0 });
        } catch (e) {
            var cancelled = window.__isUserCancel ? window.__isUserCancel(e, ctl.signal) : (e && e.name === 'AbortError');
            if (!cancelled) {
                toast(L.reverse_failed, 'error');
                ae('reverse_failed', { err: String(e && e.message || e).slice(0, 80) });
            }
        } finally {
            reversing = null;
            $('ve-rev-prog').hidden = true;
            syncInspector();
        }
    }
    on($('ve-reverse'), 'click', reverseClip);
    on($('ve-rev-cancel'), 'click', function () { if (reversing) reversing.ctl.abort(); });
    on($('ve-ov-full'), 'click', function () {
        var f = findSel(); if (!f || sel.kind !== 'overlay') return;
        var d = tl().duration;
        if (d > 0) { f.item.start = 0; f.item.end = d; }
        touch(); refresh(); commit();
        ae('overlay_full');
    });

    /* ── файлы, брошенные прямо на прибор ────────────────────────────────
       Зона загрузки свёрнута в строку, а бросать клип на ленту — привычный
       жест монтажных программ. Файлы идут через ТУ ЖЕ дверь зоны
       (__uploaderInjectFiles): размер, тип и учёт — общие. */
    var dropDepth = 0;
    function hasFiles(ev) { var t = ev.dataTransfer && ev.dataTransfer.types; return !!t && Array.prototype.indexOf.call(t, 'Files') >= 0; }
    on(ws, 'dragenter', function (ev) { if (!hasFiles(ev) || busy) return; dropDepth++; root.classList.add('is-dropping'); ev.preventDefault(); });
    on(ws, 'dragover', function (ev) { if (!hasFiles(ev) || busy) return; ev.preventDefault(); try { ev.dataTransfer.dropEffect = 'copy'; } catch (e) {} });
    on(ws, 'dragleave', function () { dropDepth = Math.max(0, dropDepth - 1); if (!dropDepth) root.classList.remove('is-dropping'); });
    on(ws, 'drop', function (ev) {
        if (!hasFiles(ev)) return;
        ev.preventDefault();
        dropDepth = 0; root.classList.remove('is-dropping');
        if (busy) return;
        var files = ev.dataTransfer.files;
        if (files && files.length && upload.__uploaderInjectFiles) { upload.__uploaderInjectFiles(files, 'drop_workspace'); ae('drop_workspace', { n: files.length }); }
    });

    /* ── масштаб ленты ──────────────────────────────────────────────────── */
    var ZMIN = 2, ZMAX = 400;
    /* Пока человек сам не менял масштаб, лента держится «вся на экране»:
       новые клипы не должны уезжать за правый край невидимыми. */
    var userZoomed = false;
    function setZoom(p, keepT) {
        var anchor = keepT != null ? keepT : playhead;
        var before = anchor * pxPerSec - scroller.scrollLeft;
        pxPerSec = clamp(p, ZMIN, ZMAX);
        $('ve-zoom').value = String(Math.round(100 * Math.log(pxPerSec / ZMIN) / Math.log(ZMAX / ZMIN)));
        renderTimeline();
        scroller.scrollLeft = Math.max(0, anchor * pxPerSec - before);
    }
    function zoomFit() {
        var w = Math.max(200, (scroller.clientWidth || 600) - 40);
        // «Вся лента» — это весь РОЛИК: хвост музыки за концом видео в файл
        // не попадёт и не должен сжимать клипы до ниток.
        var d = tl().duration;
        setZoom(w / (d > 0.5 ? d * 1.04 : extent()), 0);
        scroller.scrollLeft = 0;
    }
    function userZoom(p, keepT) { userZoomed = true; setZoom(p, keepT); }
    on($('ve-zoom'), 'input', function () { userZoom(ZMIN * Math.pow(ZMAX / ZMIN, (+this.value || 0) / 100)); });
    on($('ve-zoom-in'), 'click', function () { userZoom(pxPerSec * 1.5); });
    on($('ve-zoom-out'), 'click', function () { userZoom(pxPerSec / 1.5); });
    on($('ve-zoom-fit'), 'click', function () { userZoomed = false; zoomFit(); });
    on(scroller, 'wheel', function (ev) {
        if (!(ev.ctrlKey || ev.metaKey)) return;
        ev.preventDefault();
        userZoom(pxPerSec * (ev.deltaY < 0 ? 1.15 : 1 / 1.15), x2t(ev.clientX));
    }, { passive: false });

    /* ── клавиши ─────────────────────────────────────────────────────────
       Буквы — по ev.code (место клавиши), а не по ev.key: на арабской и
       корейской раскладке Ctrl+Z приходит другой буквой. Пока фокус на
       кнопке, флажке, вкладке или плеере результата, пробел и Delete —
       их, а не ленты: раньше пробел на кнопке запускал превью, а сама
       кнопка не нажималась. */
    var OWN_KEYS = /^(input|textarea|select|button|summary|a|video|audio)$/;
    on(document, 'keydown', function (ev) {
        if (VO && VO.isActive() && !ws.hidden) {
            var vtag = (ev.target && ev.target.tagName || '').toLowerCase();
            if (ev.key === 'Escape') { ev.preventDefault(); if (VO.isRecording()) VO.finish(); else VO.close(); return; }
            if (ev.code === 'Space' && VO.isRecording() && vtag !== 'input' && vtag !== 'textarea') { ev.preventDefault(); VO.finish(); return; }
        }
        if (ws.hidden || busy) return;
        var tg = ev.target || {}, tag = String(tg.tagName || '').toLowerCase();
        var role = tg.getAttribute ? (tg.getAttribute('role') || '') : '';
        var inItem = !!(tg.classList && tg.classList.contains('ve-item'));
        if (!inItem && (OWN_KEYS.test(tag) || tg.isContentEditable || /^(radio|tab|checkbox|slider|menuitem)$/.test(role))) {
            // Esc выводит из поля ввода — дальше снова работают клавиши ленты.
            if (ev.key === 'Escape' && ws.contains(tg) && /^(input|textarea|select)$/.test(tag)) { try { tg.blur(); } catch (e) {} }
            return;
        }
        var mod = ev.ctrlKey || ev.metaKey;
        if (mod && ev.code === 'KeyZ') { ev.preventDefault(); if (ev.shiftKey) redo(); else undo(); return; }
        if (mod && ev.code === 'KeyY') { ev.preventDefault(); redo(); return; }
        if (mod && ev.code === 'KeyD') { ev.preventDefault(); duplicateSel(); return; }
        if (mod || ev.altKey) return;
        if (ev.code === 'Space') { ev.preventDefault(); togglePlay(); }
        else if (ev.key === 'ArrowLeft') { ev.preventDefault(); seekTo(playhead - (ev.shiftKey ? 1 : frameStep())); }
        else if (ev.key === 'ArrowRight') { ev.preventDefault(); seekTo(playhead + (ev.shiftKey ? 1 : frameStep())); }
        else if (ev.key === 'Home') { ev.preventDefault(); seekTo(0); }
        else if (ev.key === 'End') { ev.preventDefault(); seekTo(tl().duration); }
        else if (ev.code === 'KeyS') { ev.preventDefault(); splitNow(); }
        else if (ev.key === 'Delete' || ev.key === 'Backspace') { if (sel) { ev.preventDefault(); deleteSel(); } }
        else if (ev.key === '+' || ev.key === '=') userZoom(pxPerSec * 1.5);
        else if (ev.key === '-') userZoom(pxPerSec / 1.5);
        else if (ev.key === 'Escape') select(null);
    });

    /* ── вывод ──────────────────────────────────────────────────────────── */
    function chooseTarget(t) {
        var resVal = $('ve-res').value, fpsVal = $('ve-fps').value;
        var short = 0, fps = 0;
        t.clips.forEach(function (c) {
            if (c.kind !== 'video') return;
            var rec = media.get(c.mediaId);
            var w = (rec && rec.width) || c.width, h = (rec && rec.height) || c.height;
            if (w && h) short = Math.max(short, Math.min(w, h));
            if (rec && rec.fps > fps) fps = rec.fps;
        });
        if (resVal !== 'auto') short = parseInt(resVal, 10) || 1080;
        else short = short ? Math.min(2160, short) : 1080;
        var sz = TL.outputSize(aspectRatio(), short);
        var tfps = fpsVal !== 'auto' ? (parseInt(fpsVal, 10) || 30) : (fps > 0 ? clamp(Math.round(fps), 15, 60) : 30);
        return { tw: sz.w, th: sz.h, fps: tfps };
    }
    function crfOf() { return ({ high: 18, medium: 23, low: 28 })[$('ve-quality').value] || 20; }
    function mbText(bytes) { var mb = bytes / 1048576; return (mb < 10 ? nfmt(mb, 1) : String(Math.round(mb))); }
    /* Размер словами для человека: от гигабайта — в гигабайтах («1448 МБ» читается хуже, чем «1,4 ГБ»). */
    function sizeText(bytes) {
        var mb = (bytes || 0) / 1048576;
        return mb >= 1024 ? nfmt(mb / 1024, 1) + ' ' + (L.gb || 'GB') : mbText(bytes || 0) + ' ' + (L.mb || 'MB');
    }
    function updateEstimate() {
        var t = tl(), el = $('ve-est');
        if (!el) return;
        if (!(t.duration > 0) || !t.clips.length) { el.textContent = ''; return; }
        var g = chooseTarget(t);
        var bytes = (window.CanvasVideoExport && window.CanvasVideoExport.estimateBytes)
            ? window.CanvasVideoExport.estimateBytes(g.tw, g.th, g.fps, crfOf(), t.duration, true)
            : ((g.tw * g.th * g.fps * 0.12 + 192000) / 8) * t.duration;
        el.textContent = String(L.est_size || ':w×:h · :fps · ≈ :size')
            .replace(':w', g.tw).replace(':h', g.th).replace(':fps', String(g.fps))
            .replace(':dur', fmt(t.duration)).replace(':size', mbText(bytes));
    }
    ['ve-res', 've-fps', 've-quality', 've-format'].forEach(function (id) { on($(id), 'change', updateEstimate); });

    /* «Собрать видео» и «Отмена» — одна кнопка. Двойной щелчок по ней больше
       не отменяет сборку, которую запустил первый щелчок (разбор 30.09):
       отмена принимается только спустя секунду после пуска. */
    function exportCrashed(err) {
        finishBusy();
        $('ve-prog').hidden = true;
        if (window.__handleError) window.__handleError(err, SLUG + '/export', { say: L.error_unknown });
        else toast(L.error_unknown, 'error');
    }
    function exportClick(ev) {
        if (busy) {
            if (ev && ev.detail > 1) return;
            if (Date.now() - exportStartedAt < 1000) return;
            if (abortCtl) abortCtl.abort();
            return;
        }
        if (picking) return;
        if (ev && ev.detail > 1) return;
        runExport().catch(exportCrashed);
    }
    on($('ve-export'), 'click', exportClick);
    on($('ve-export-top'), 'click', exportClick);
    on($('ve-reset'), 'click', function () { if (busy) return; resetAll(); });

    /* ── куда положить готовое видео ────────────────────────────────────────
       Сборка складывает файл во внутреннее хранилище браузера, а оно лежит на
       СИСТЕМНОМ диске. Обращение 12.10.2026 (Яндекс Браузер, Windows): пять
       сборок 16-минутного ролика (≈ 985 МБ) подряд кончались «на диске не
       хватает места», и редактор не предлагал, куда ещё положить файл. Выход
       теперь есть: человек выбирает место сам, и кодировщик пишет прямо туда,
       на любой диск (__pickedMuxLane в ядре); либо сборка идёт в память, если
       файл в неё помещается. Та же кнопка стоит и рядом с «Собрать видео» —
       место можно выбрать заранее, не дожидаясь отказа. */
    var picking = false;                    // открыт диалог «куда сохранить»
    var pickDead = false;                   // диалог здесь не открывается (встроенный браузер)
    var roomAsk = null;                     // чем кончилась сборка, на которую отвечает панель
    function canPick() { return !pickDead && !!(window.__pickSaveHandle && window.__pickSaveHandle.available()); }
    function syncPickUi() { var b = $('ve-export-to'); if (b) b.hidden = busy || !canPick(); }
    function exportExt() { return ($('ve-format') && $('ve-format').value) === 'webm' ? 'webm' : 'mp4'; }
    function estBytes(t, g) {
        var CVE = window.CanvasVideoExport;
        return (CVE && CVE.estimateBytes) ? CVE.estimateBytes(g.tw, g.th, g.fps, crfOf(), t.duration, true) : 0;
    }
    function fitsMemory(bytes) {
        var c = window.CanvasVideoExport && window.CanvasVideoExport.memoryTargetCeiling;
        return !!c && bytes > 0 && bytes <= c;
    }
    /* Есть ли что собирать — до диалога и до списания, одними словами со сборкой. */
    function exportReady(t) {
        if (!t.clips.length || !(t.duration > 0)) { toast(L.need_clip, 'error'); return false; }
        if (!window.VideoMergeWebCodecs || !window.CanvasVideoExport) { toast(L.unsupported_browser, 'error'); return false; }
        var gone = missingNames();
        if (gone.length) {
            toast(String(L.missing_export || '').replace(':names', gone.join(', ')), 'error');
            showNotice(String(L.draft_missing || '').replace(':names', gone.join(', ')), 'missing');
            return false;
        }
        return true;
    }
    /* Единица списания — ВСЯ композиция, по ИСХОДНЫМ файлам (ключ из черновика
       после F5 — тот же, что до него: limitKeyOf). */
    function beginUnit() {
        if (!window.__toolLimit) return { ok: true, token: null };
        var keys = usedRecords().map(limitKeyOf).filter(Boolean);
        var token = window.__toolLimit.begin(SLUG, 'set:' + keys.sort().join('|'));
        return { ok: !!token, token: token };
    }
    /* Файл, который диалог создал пустым, а сборка в него не пошла, — убрать;
       файл с байтами — чужой, его не трогаем. */
    function discardPicked(handle) {
        try {
            if (!handle || typeof handle.remove !== 'function') return;
            handle.getFile().then(function (f) { if (f && !f.size) return handle.remove(); }).catch(function () {});
        } catch (e) {}
    }
    async function writeToPicked(handle, blob) {
        var w = await handle.createWritable();
        try { await w.write(blob); await w.close(); }
        catch (e) { try { await w.abort(); } catch (e2) {} throw e; }
        return handle.getFile();
    }
    function hideRoom() { var el = $('ve-room'); if (el) el.hidden = true; roomAsk = null; }
    /* o: { bytes, picked — отказало выбранное место, full — именно нехватка места,
       memory — отказала сборка в память } */
    function showRoom(o) {
        var el = $('ve-room');
        if (!el) { toast(L.disk_full, 'error'); return; }
        roomAsk = o;
        var size = sizeText(o.bytes || 0);
        var pick = canPick(), mem = !o.memory && fitsMemory(o.bytes);
        var body = o.picked ? (o.full ? L.room_picked_full : L.save_failed) : (pick ? L.room_body : L.room_body_nopick);
        var title = String(L.room_title || '').replace(':size', size);
        $('ve-room-title').textContent = title;
        $('ve-room-body').textContent = String(body || '').replace(':size', size);
        $('ve-room-pick').hidden = !pick;
        $('ve-room-mem').hidden = !mem;
        $('ve-room-mem-hint').hidden = !mem;
        el.hidden = false;
        try { el.scrollIntoView({ block: 'nearest' }); } catch (e) {}
        if (window.__announce) window.__announce(title);
        ae('export_room_prompt', { pick: pick ? 1 : 0, mem: mem ? 1 : 0, mb: Math.round((o.bytes || 0) / 1048576), picked: o.picked ? 1 : 0 });
    }
    /* «Сохранить в…»: сперва единица (синхронно, в нажатии), потом диалог —
       ему нужен этот же жест; закрытый диалог возвращает единицу. */
    function exportToClick(ev, from) {
        if (busy || picking) return;
        if (ev && ev.detail > 1) return;
        var t = tl();
        if (!exportReady(t)) return;
        var unit = beginUnit();
        if (!unit.ok) return;
        var ext = exportExt();
        picking = true;
        ae('export_to_pick', { from: from });
        window.__pickSaveHandle({ suggestedName: outputName(t, ext), mime: ext === 'webm' ? 'video/webm' : 'video/mp4' }).then(function (handle) {
            picking = false;
            if (handle) return runExport({ handle: handle, token: unit.token });
            var why = (window.__pickSaveHandle.last || {}).why || '';
            ae('export_to_pick_none', { from: from, why: why });
            if (why === 'cancel') { if (unit.token) unit.token.abort(); return; }
            // Диалога здесь нет вовсе: кнопка больше не обещает того, чего не будет.
            pickDead = true; syncPickUi();
            if (from === 'room') { if (unit.token) unit.token.abort(); if (roomAsk) showRoom(roomAsk); return; }
            return runExport({ token: unit.token });
        }).catch(function (err) { picking = false; exportCrashed(err); });
    }
    on($('ve-export-to'), 'click', function (ev) { exportToClick(ev, 'button'); });
    on($('ve-room-pick'), 'click', function (ev) { exportToClick(ev, 'room'); });
    on($('ve-room-mem'), 'click', function (ev) {
        if (busy || picking) return;
        if (ev && ev.detail > 1) return;
        ae('export_room_memory');
        runExport({ memory: true }).catch(exportCrashed);
    });
    syncPickUi();
    window.addEventListener('load', syncPickUi, { once: true });   // ядро могло прийти позже этого скрипта

    /* keepDraft — лента очищается под другой проект (открытие из списка),
       а не по «Новый монтаж»: текущий черновик тогда не отпускается здесь. */
    function resetAll(keepDraft) {
        if (VO && VO.isActive()) VO.close();
        if (DR && !keepDraft) DR.fresh();
        preview.pause(); setPlayBtn(false);
        preview.dispose();
        project = emptyProject();
        sel = null; playhead = 0; hist = { stack: [], idx: -1, key: null, at: 0 };
        thumbCache = {}; waveCache = {};
        media.dispose();
        clearResult();
        hideRoom();
        touch();
        ws.hidden = true;
        $('ve-prog').hidden = true;
        syncUndo();
        guardLeave();
        if (!keepDraft) {
            hideNotice();
            // Зона загрузки — снова большая: строка с именами прежних файлов
            // висела над пустой лентой (разбор 30.09).
            try { if (upload.__uploaderRestore) upload.__uploaderRestore(true); } catch (e) {}
        }
        refreshProjects();
    }

    /* Прежний результат, который человек так и не скачал, уходит с экрана — и
       обязан уйти с диска: его временный файл жил ещё 30 минут, и в обычном
       цикле «поправил — собрал заново» два-три ролика по гигабайту лежали в
       хранилище браузера одновременно (а новая сборка просила место рядом с
       ними). Файл, отданный на скачивание, закреплён (__downloadFile) — браузер
       может ещё читать его, такой не трогаем: его уберёт таймер. */
    function releaseResultFile(res) {
        try {
            var b = res && res.blob, name = b && b.name;
            if (!name || res.saved || !/^_cve_\d/.test(name)) return;
            if (window.__opfsOwner && window.__opfsOwner.pinned(name)) return;
            if (!(navigator.storage && navigator.storage.getDirectory)) return;
            navigator.storage.getDirectory()
                .then(function (root) { return root.removeEntry(name); })
                .then(function () { ae('result_temp_released', { mb: Math.round((b.size || 0) / 1048576) }); })
                .catch(function () {});
        } catch (e) {}
    }
    function clearResult() {
        if (lastResult && lastResult.url) { try { URL.revokeObjectURL(lastResult.url); } catch (e) {} }
        var gone = lastResult;
        lastResult = null; resultSnap = null;
        $('ve-result').hidden = true;
        $('ve-result-stale').hidden = true;
        if ($('ve-result-saved')) $('ve-result-saved').hidden = true;
        var v = $('ve-result-video'); try { v.removeAttribute('src'); v.load(); } catch (e) {}
        // После того как плеер отпустил файл.
        if (gone) releaseResultFile(gone);
    }
    /* Результат собран из другой ленты — сказать это рядом с «Скачать». */
    function syncStale() {
        var el = $('ve-result-stale');
        if (!el || !lastResult) return;
        el.hidden = snap() === resultSnap;
    }

    /** Клип, который быстрый лейн не взял (кодек без декодера) — копия в
        кодеке, который этот браузер декодирует: H.264, а если отказан сам H.264
        (WebCodecs Яндекса 24 на Windows 7/8 без видеоадаптера и Яндекса на Linux
        говорят «умею» и не декодируют — разбор 30.10), VP8 в WebM: его
        программный декодер есть в любом Chromium. */
    async function liftForEngine(file, target, signal, codec) {
        if (typeof window.__ensureFFmpeg === 'function') await window.__ensureFFmpeg();
        var F = window.FFmpegProcessor;
        if (!F || typeof F.processStreaming !== 'function') return null;
        // «Отмена» во время перекодирования останавливает FFmpeg сразу, а не
        // после того, как он доработает минуты (разбор 30.09).
        var stop = function () { try { F.cancel(); } catch (e) {} };
        if (signal) signal.addEventListener('abort', stop);
        try {
            var scale = "scale='min(" + target.tw + ",iw)':-2";
            var vp8 = codec === 'vp8';
            /* VP8 — промежуточная копия, а не выход: битрейт с запасом
               (~0,2 бит/пиксель при частоте вывода), realtime — иначе libvpx в
               WebAssembly кодирует в разы дольше клипа. */
            var vbps = Math.round(Math.min(40e6, Math.max(2e6, target.tw * target.th * (target.fps || 30) * 0.2)));
            var args = vp8
                ? ['-map', '0:v:0', '-map', '0:a:0?', '-vf', scale, '-c:v', 'libvpx', '-deadline', 'realtime', '-cpu-used', '8',
                    '-b:v', String(vbps), '-crf', '8', '-auto-alt-ref', '0', '-pix_fmt', 'yuv420p', '-c:a', 'libopus', '-b:a', '192k', '-ac', '2']
                : ['-map', '0:v:0', '-map', '0:a:0?', '-vf', scale, '-c:v', 'libx264', '-preset', 'veryfast',
                    '-crf', '18', '-pix_fmt', 'yuv420p', '-c:a', 'aac', '-b:a', '192k', '-ac', '2'];
            var res = await F.processStreaming(file, args, vp8 ? 've-lift.webm' : 've-lift.mp4');
            if (!res || !res.blob || !res.blob.size) return null;
            try { if (res.url) URL.revokeObjectURL(res.url); } catch (e) {}
            return new File([res.blob], String(file.name || 'clip').replace(/\.[^.]+$/, '') + (vp8 ? '.webm' : '.mp4'), { type: vp8 ? 'video/webm' : 'video/mp4' });
        } finally {
            if (signal) signal.removeEventListener('abort', stop);
        }
    }

    /* Наложения в файл — в размере кадра вывода: превью держит картинку до
       1600 px, а логотип на весь кадр 4K из неё вышел бы мыльным. */
    async function prepareOverlayBitmaps(t, target) {
        var need = {};
        t.overlays.forEach(function (o) { need[o.mediaId] = Math.max(need[o.mediaId] || 0, Math.ceil(o.w * target.tw)); });
        var made = [];
        for (var id in need) {
            var r = media.get(id);
            if (!r || !r.file || !r.bitmap || r.bitmap.width >= need[id] || r.width <= r.bitmap.width) continue;
            try {
                var w = Math.min(r.width, need[id]), h = Math.max(1, Math.round(w * r.height / r.width));
                r.exportBitmap = await createImageBitmap(r.file, { resizeWidth: w, resizeHeight: h, resizeQuality: 'high' });
                made.push(r);
            } catch (e) {}
        }
        return function release() { made.forEach(function (r) { try { r.exportBitmap.close(); } catch (e) {} r.exportBitmap = null; }); };
    }

    /* how: { handle — файл, выбранный человеком: кодировщик пишет прямо в него;
              memory — без временного файла на диске;
              token — единица уже взята (до диалога выбора места) } */
    async function runExport(how) {
        how = how || {};
        var snapProject = copy(project);
        var t = TL.build(snapProject.clips, snapProject.texts, { audio: snapProject.audio, overlays: snapProject.overlays });
        var token = how.token || null;
        if (!exportReady(t)) { if (token) token.abort(); discardPicked(how.handle); return; }
        preview.pause(); setPlayBtn(false);

        if (!token) {
            var unit = beginUnit();
            if (!unit.ok) return;
            token = unit.token;
        }

        var handle = how.handle || null;
        var est = 0;
        busy = true;
        exportStartedAt = Date.now();
        abortCtl = new AbortController();
        clearResult();
        hideRoom();
        syncPickUi();
        root.classList.add('is-busy');
        $('ve-export-l').textContent = L.cancel || 'Cancel';
        $('ve-export-top').lastChild.textContent = L.cancel || 'Cancel';
        $('ve-prog').hidden = false;
        try { $('ve-out').scrollIntoView({ block: 'nearest' }); } catch (e) {}
        setProg(0.02, L.stage_prepare, '');
        var t0 = Date.now();
        var releaseOverlays = null, ovSourcesClose = null;

        try {
            // «Как у видео» — частота источника, а её заголовок читается после добавления.
            await media.fpsSettled(t.clips.filter(function (c) { return c.kind === 'video'; }).map(function (c) { return c.mediaId; }), 8000);
            var target = chooseTarget(t);
            var fmtSel = exportExt();
            var crf = crfOf();
            est = estBytes(t, target);
            var opts = {
                format: fmtSel, crf: crf, target: target, layout: t.layout, matroska: true, slug: SLUG,
                noDiskTarget: !!how.memory,
                audioItems: t.audio.map(function (a, j) {
                    var r = media.get(a.mediaId), sp = t.itemSpan(j);
                    return r ? { file: r.lifted || r.file, start: sp.start, len: sp.len, trimStart: a.trimStart, trimEnd: a.trimEnd,
                        loop: a.loop, env: t.itemEnv(j), volume: a.volume } : null;
                }).concat(t.overlays.map(function (o, j) {
                    // Звук видео поверх видео: отрезок его файла на месте наложения.
                    if (o.kind !== 'video' || !o.hasAudio || o.mute || !(o.volume > 0)) return null;
                    var r = media.get(o.mediaId), len = Math.min(o.end, t.duration) - o.start;
                    return r ? { file: r.lifted || r.file, start: o.start, len: len, trimStart: o.trimStart, trimEnd: o.trimStart + Math.max(0, len),
                        loop: false, env: t.ovEnv(j), volume: o.volume } : null;
                })).filter(function (x) { return x && x.len > 0.01; }),
            };
            var engineClips = t.clips.map(function (c, i) {
                if (c.kind === 'color') {
                    // Заставку рисует компоновщик сам; движку нужен лишь «курсор»-картинка.
                    return { kind: 'image', duration: c.trimEnd - c.trimStart, trimStart: 0, trimEnd: c.trimEnd - c.trimStart, speed: 1,
                        hasAudio: false, width: target.tw, height: target.th, fps: 0,
                        image: function () { return createImageBitmap(new ImageData(2, 2)); },
                        releaseImage: function (b) { if (b && b.close) b.close(); } };
                }
                var r = media.get(c.mediaId);
                if (c.kind === 'image') {
                    return { kind: 'image', duration: c.trimEnd - c.trimStart, trimStart: 0, trimEnd: c.trimEnd - c.trimStart, speed: 1,
                        hasAudio: false, width: r.width, height: r.height, fps: 0,
                        image: function () { return media.imageForExport(r, target.tw * (c.zoom || 1), target.th * (c.zoom || 1), c.fit, c.rotation); },
                        releaseImage: function (b) { if (b && b.close) b.close(); } };
                }
                return { file: r.lifted || r.file, duration: c.duration, width: r.width, height: r.height, fps: r.fps, hasAudio: c.hasAudio,
                    trimStart: c.trimStart, trimEnd: c.trimEnd, speed: c.speed, rotation: c.rotation,
                    volume: Math.round(c.volume * 100), mute: c.mute, audioFadeIn: 0, audioFadeOut: 0, env: t.clipEnv(i), mediaId: c.mediaId };
            });
            var transitions = [];
            for (var i = 0; i < engineClips.length - 1; i++) {
                var tx = t.clips[i].tx;
                transitions.push(tx && t.overlaps[i] > 0 ? { type: tx.type, duration: t.overlaps[i] } : { type: 'none', duration: 0 });
            }

            var VM = window.VideoMergeWebCodecs;
            var probe = await VM.probe(engineClips, opts);
            var lifts = 0, refusedClip = null;
            while (!probe.mode && typeof probe.clip === 'number' && lifts < engineClips.length * 2 && engineClips[probe.clip].kind !== 'image') {
                var ec = engineClips[probe.clip];
                var mr = media.get(ec.mediaId);
                /* В какой кодек переводить: декодер этого браузера отказал самому
                   H.264 (проба — настоящим ключевым кадром) — значит, и копия в
                   H.264 будет отказана; тогда VP8. Тот же перевод второй раз не
                   поможет — выходим с названным клипом. */
                var refusedH264 = /^decoder-(refused|unsupported):(avc[13]|h264)/i.test(String(probe.reason || ''));
                var liftCodec = refusedH264 ? 'vp8' : 'h264';
                refusedClip = { name: (mr && mr.name) || (ec.file && ec.file.name) || '', reason: String(probe.reason || '') };
                if (mr && mr.liftedAs === liftCodec) break;
                lifts++;
                setProg(0.04, L.stage_lift, '');
                var lifted = await liftForEngine((mr && mr.file) || ec.file, target, abortCtl.signal, liftCodec);
                if (abortCtl.signal.aborted) throw new DOMException('Aborted', 'AbortError');
                if (!lifted) break;
                // Перекодированная копия живёт у записи файла: следующая сборка
                // после правки ленты её уже не перекодирует.
                engineClips.forEach(function (e2) { if (e2.mediaId === ec.mediaId) e2.file = lifted; });
                if (mr) { mr.lifted = lifted; mr.liftedAs = liftCodec; }
                probe = await VM.probe(engineClips, opts);
                ae('export_lift', { codec: liftCodec, reason: String(probe.reason || '').slice(0, 40) });
            }
            if (!probe || !probe.mode) {
                var unav = new Error('webcodecs-unavailable:' + (probe && probe.reason || '?'));
                unav.clipName = refusedClip && /^(decoder-|demux-|avcc-|no-dims|non-mp4)/.test(refusedClip.reason) ? refusedClip.name : '';
                unav.clipDecode = !!(refusedClip && /^decoder-/.test(refusedClip.reason));
                throw unav;
            }
            opts.outFormat = probe.outFormat || fmtSel;
            /* Кодировщик этого компьютера не делает частоту проекта в таком
               размере, а иначе выходил бы VP9 в .mp4, который не открывают
               iPhone, WhatsApp и плеер Windows: собираем в половинной частоте
               (каждый второй кадр) — сказать это человеку до ожидания. */
            if (probe.target && probe.target.fpsStep) {
                toast(String(L.fps_stepped || '').replace(/:to/g, probe.target.fpsStep.to).replace(/:from/g, probe.target.fpsStep.from), 'info');
                ae('export_fps_stepped', { from: probe.target.fpsStep.from, to: probe.target.fpsStep.to, h: probe.target.th });
            }
            if (opts.outFormat !== fmtSel) {
                toast(probe.reason === 'split-too-large-webm' ? L.webm_audio_fallback : L.webm_fallback, 'info');
                // Файл выбран под другой формат: в «.mp4» WebM не пишем — видео
                // соберётся обычным путём и отдастся кнопкой «Скачать».
                if (handle) { discardPicked(handle); handle = null; ae('export_to_format_changed'); }
            }
            est = estBytes(t, probe.target) || est;
            opts.outputHandle = handle;

            // Гарнитуры титров — ДО первого кадра: канва не ждёт шрифт сама, и
            // титр вышел бы в файле запасным шрифтом.
            if (OV && OV.ensureFonts && t.texts.length) await OV.ensureFonts(t.texts, 6000);
            if (t.overlays.length) releaseOverlays = await prepareOverlayBitmaps(t, probe.target);
            var E = window.__acETA;
            if (E) E.beginStage('ve-export');
            setProg(0.06, L.stage_render, '');
            var regionsSnap = snapProject.regions;
            var ovOpen = {};
            ovSourcesClose = function () {
                Object.keys(ovOpen).forEach(function (id) { var x = ovOpen[id]; if (x && x.src) { try { x.src.close(); } catch (e) {} } });
                ovOpen = {};
            };
            async function ovFrames(tSec) {
                var vis = t.overlaysAt(tSec), map = null;
                for (var q = 0; q < vis.length; q++) {
                    var v = vis[q], o = v.item;
                    if (o.kind !== 'video' || v.sourceSec == null) continue;
                    var slot = ovOpen[o.id];
                    if (!slot) {
                        var r = media.get(o.mediaId);
                        slot = ovOpen[o.id] = { src: null, end: o.end };
                        if (r && window.SlideshowClipSource) {
                            // compose.js рисует наложение через VideoOrientation — копия кадра не нужна
                            try { slot.src = await window.SlideshowClipSource.openForExport(r.lifted || r.file, probe.target.fps, o.trimStart, { slug: SLUG, deferRotation: true }); } catch (e) { slot.src = null; }
                        }
                        if (!slot.src) ae('overlay_video_unreadable');
                    }
                    if (!slot.src) continue;
                    var fr2 = null;
                    try { fr2 = await slot.src.frameAt(v.sourceSec); } catch (e) { fr2 = null; }
                    if (fr2) { map = map || {}; map[o.id] = fr2; }
                }
                // Отрезок кончился — декодер больше не нужен.
                Object.keys(ovOpen).forEach(function (id) {
                    var x = ovOpen[id];
                    if (x && tSec > x.end + 0.25) { if (x.src) { try { x.src.close(); } catch (e) {} } ovOpen[id] = { src: null, end: -1, done: true }; }
                });
                return map;
            }
            var blob = await VM.merge(engineClips, transitions, probe.target, opts, {
                signal: abortCtl.signal,
                onProgress: function (p) {
                    p = Math.max(0, Math.min(1, p));
                    var eta = '';
                    if (E) { E.updateRate('ve-export', p); var rs = E.remainingSec('ve-export'); if (rs) eta = String(L.eta || '≈ :time').replace(':time', etaText(rs)); }
                    setProg(0.06 + p * 0.93, p < 0.97 ? L.stage_render : L.stage_encode, eta);
                },
                // Кадр ФАЙЛА рисует тот же код, что и превью.
                compose: async function (ctx2, tSec, W2, H2, frameOf) {
                    var fr = t.frameAt(tSec);
                    var sa = fr ? await frameOf(fr.a.index, fr.a.sourceSec) : null;
                    var sb = (fr && fr.b) ? await frameOf(fr.b.index, fr.b.sourceSec) : null;
                    var ovs = t.overlays.length ? await ovFrames(tSec) : null;
                    C.draw(ctx2, W2, H2, tSec, t, fr, sa, sb, regionsSnap, ovs);
                },
            });
            if (E) E.endStage('ve-export');

            var ext = (opts.outFormat === 'webm') ? 'webm' : 'mp4';
            /* Файл уже лежит там, куда его велел положить человек, — если
               кодировщик писал прямо в него. Лейн, собирающий файл через FFmpeg,
               отдаёт готовое целиком: дописываем в выбранное место сами. */
            var saved = !!(handle && blob && blob.__savedToPicked);
            if (handle && !saved) {
                try { blob = await writeToPicked(handle, blob); saved = true; }
                catch (e) {
                    toast(L.save_failed, 'error');
                    ae('export_to_write_failed', { err: String(e && e.name || e).slice(0, 40) });
                    discardPicked(handle);
                }
            }
            var name = (saved && handle.name) || outputName(t, ext);
            showResult(blob, name, probe.target, t.duration, JSON.stringify(snapProject), saved);
            setProg(1, L.result_ready, '');
            if (token) token.commit();
            if (saved) {
                ae('file_download', { via: 'picked_stream', src: 'direct', ok: 1, ext: ext, sizeKB: Math.round(blob.size / 1024) });
                if (DR) DR.exported();
            }
            try {
                window.__aeToolComplete && window.__aeToolComplete({
                    slug: SLUG, clips: t.clips.length, images: t.clips.filter(function (c) { return c.kind === 'image'; }).length,
                    cards: t.clips.filter(function (c) { return c.kind === 'color'; }).length,
                    texts: t.texts.length, audio: t.audio.length, overlays: t.overlays.length, tx: t.overlaps.filter(function (o) { return o > 0; }).length,
                    redact: snapProject.regions.length, aspect: snapProject.aspect, lifts: lifts,
                    dur: Math.round(t.duration), fmt: ext, mode: probe.mode, w: probe.target.tw, h: probe.target.th, ms: Date.now() - t0,
                });
            } catch (e) {}
        } catch (err) {
            if (token) token.abort();                 // отказ — не покупка
            discardPicked(handle);                    // пустой файл в выбранном месте — не результат
            var cancelled = window.__isUserCancel ? window.__isUserCancel(err, abortCtl && abortCtl.signal) : (err && err.name === 'AbortError');
            if (cancelled) { finishBusy(); $('ve-prog').hidden = true; return; }
            var msg = String(err && err.message || err);
            $('ve-prog').hidden = true;
            /* Не хватило МЕСТА (или выбранное место не приняло файл) — это не
               тост, а развилка: куда ещё положить файл, решает человек.
               Остальные отказы, которые повтор не исправит, говорят, ЧТО сделать
               (#1990: 15 сборок подряд под одним «Не удалось собрать видео»). */
            var noRoom = !!(err && err.diskFull) || /^opfs-write-failed:/.test(msg);
            if (noRoom || (err && err.picked)) showRoom({ bytes: est, picked: !!(err && err.picked), full: noRoom, memory: !!how.memory });
            else if (err && err.code === 'SPLIT_TOO_LARGE') toast(L.split_too_large, 'error');
            else if (err && err.code === 'SPLIT_AUDIO_MUX_FAILED') toast(L.split_audio_failed, 'error');
            else if (/memory|oom|quota|too-large|allocation/i.test(msg)) toast(L.oom_error, 'error');
            else if (err && err.clipName) toast(String((err.clipDecode ? L.clip_decode_refused : L.clip_unreadable) || '').replace(':name', err.clipName), 'error');
            else if (/webcodecs-unavailable|no-webcodecs|cve:/.test(msg)) toast(L.unsupported_browser, 'error');
            else throw err;
            ae('export_failed', { err: msg.slice(0, 100) });
        } finally {
            if (releaseOverlays) releaseOverlays();
            if (ovSourcesClose) { try { ovSourcesClose(); } catch (e) {} ovSourcesClose = null; }
            finishBusy();
        }
    }
    function etaText(s) {
        if (s < 60) return Math.max(1, Math.round(s)) + ' ' + (L.sec || 's');
        var m = Math.round(s / 60);
        return m + ' ' + (L.min || 'min');
    }

    function showResult(blob, name, target, dur, fromSnap, saved) {
        var url = URL.createObjectURL(blob);
        lastResult = { blob: blob, name: name, url: url, saved: !!saved };
        resultSnap = fromSnap || snap();
        // Файл записан в выбранное место — сказать это рядом с «Скачать».
        var sv = $('ve-result-saved');
        if (sv) { sv.textContent = saved ? String(L.saved_to || '').replace(':name', name) : ''; sv.hidden = !saved; }
        // Файл уже лежит у человека: «Скачать» остаётся, но не главной кнопкой.
        var dlb = $('ve-download'); if (dlb) dlb.classList.toggle('ghost', !!saved);
        var v = $('ve-result-video');
        v.src = url;
        $('ve-result-meta').innerHTML = String(L.result_meta || ':name · :w×:h · :dur · :size')
            .replace(':name', '<b>' + esc(name) + '</b>').replace(':w', target.tw).replace(':h', target.th)
            .replace(':dur', fmt(dur)).replace(':size', sizeText(blob.size));
        $('ve-result').hidden = false;
        syncStale();
        try { $('ve-result').scrollIntoView({ block: 'nearest' }); } catch (e) {}
    }
    on($('ve-download'), 'click', function () {
        if (!lastResult) return;
        if (window.__downloadFile) window.__downloadFile(lastResult.blob, lastResult.name);
        ae('download');
        if (DR) DR.exported();
    });

    function finishBusy() {
        busy = false; abortCtl = null;
        syncPickUi();
        root.classList.remove('is-busy');
        $('ve-export-l').textContent = L.export_btn || 'Export';
        $('ve-export-top').lastChild.textContent = L.export_btn || 'Export';
    }
    function setProg(frac, label, eta) {
        $('ve-bar-i').style.width = Math.round(Math.max(0, Math.min(1, frac)) * 100) + '%';
        $('ve-stage-text').textContent = label || '';
        $('ve-eta').textContent = eta || '';
    }

    function outputName(t, ext) {
        // Имя от МАТЕРИАЛА, а не константа: за сессию копятся «(1)(2)(3)».
        var base = 'montage';
        var first = t.clips.filter(function (c) { return c.kind !== 'color'; })[0];
        if (first) {
            var raw = String(first.name || '').replace(/\.[^.]+$/, '');
            try { base = (window.__outputName && window.__outputName.sanitize) ? (window.__outputName.sanitize(raw) || base) : (raw.replace(/[\\/:*?"<>|]+/g, '') || base); }
            catch (e) {}
        }
        return base + '-edit.' + ext;
    }

    // Тестовый крючок: состояние ленты снаружи не видно. Только чтение.
    window.__veDebug = {
        get clips() { return project.clips.length; },
        get texts() { return project.texts.length; },
        get audio() { return project.audio.length; },
        get overlays() { return project.overlays.length; },
        get duration() { return tl().duration; },
        get playhead() { return playhead; },
        get busy() { return busy; },
        get selection() { return sel ? sel.kind + ':' + sel.id : null; },
        get pxPerSec() { return pxPerSec; },
        get aspect() { return project.aspect; },
        get canvasSize() { return { w: canvas.width, h: canvas.height }; },
        get history() { return { idx: hist.idx, n: hist.stack.length }; },
        get hasAudio() { return project.clips.map(function (c) { return c.hasAudio; }); },
        get result() { return lastResult ? { name: lastResult.name, size: lastResult.blob.size, saved: !!lastResult.saved } : null; },
        get previewSettled() { return preview.settled(); },
        get voicePhase() { return VO ? VO.phase() : 'none'; },
        get tab() { return clipTab; },
        frameSourceAt: function (tt) { var s = tl().frameSource(tt); return s ? { index: s.index, sourceSec: s.sourceSec } : null; },
        frameAt: function (tt) { var f = tl().frameAt(tt); return f ? { a: f.a.index, b: f.b ? f.b.index : null, prog: f.prog, type: f.type } : null; },
        layout: function () { return tl().layout; },
        get draftId() { return DR ? DR.current() : null; },
        target: function () { return chooseTarget(tl()); },
        project: function () { return copy(project); },
        mediaState: function () { return media.all().map(function (r) { return { id: r.id, kind: r.kind, state: r.state, converted: r.converted, hasAudio: r.hasAudio, peaks: !!r.peaks }; }); },
    };

    var rsT = 0;
    // A wider window — or the wide-screen layout (WideWorkspace) — gives the
    // ribbon room; in «fit» mode the whole film is re-fitted to it, otherwise 60 %
    // of a 2560 px timeline stayed empty. A zoom the person chose stays theirs.
    window.addEventListener('resize', function () { clearTimeout(rsT); rsT = setTimeout(function () { if (!userZoomed) zoomFit(); else renderTimeline(); }, 120); });
    setPlayBtn(false);
    syncUndo();
    if (DR) DR.boot().then(refreshProjects, refreshProjects);
});
})();
